<template>
    <div v-if="previwEmit">
     <b-card>
        <div slot="header">
            <b-row>
              <b-col>
                <div class="text-center">
                  <template>
                    <h3 class="display-">Guía de Remision Electrónica</h3> 
                  </template>
                </div>
              </b-col>
            </b-row>
            <b-row align-v="center">
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                    <div class="campo-con-label">
                        <label>Fecha Emisión</label>

                        <datepicker 
                            class="bordesYtexto"
                            v-model="femision" 
                            :format="customFormatter" 
                            :language="es" 
                            :bootstrap-styling="true" 
                            :disabledDates="diasnopermitidos" 
                            :placeholder="currentdate">
                        </datepicker>
                    </div>
                </b-col>
                <b-col cols="6"></b-col>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                    <select class="custom-select mr-sm-2 mt-4" v-model="tipodeguia">
                        <option v-for="tipo in tiposdeguia" :value="tipo.codigo" :key="tipo.codigo">{{ tipo.nombre }}</option>
                    </select>
                </b-col>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                    <select class="custom-select mr-sm-2 mt-4" v-model="motivotraslado">
                        <option v-for="tipo in motivodetraslado" :value="tipo.codigo" :key="tipo.codigo">{{ tipo.nombre }}</option>
                    </select>
                </b-col>
            </b-row>
        </div>
        <b-card style="border: #00b3b3 3px solid;">
          
        <h5 v-if="motivotraslado == '02'"><p class="titulosPrimarios">Datos Comprador</p></h5>
        <h5 v-else><p class="titulosPrimarios">Datos del Destinatario</p></h5>
        <b-row>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                <template>
                    <b-select class="bordesYtexto input-buscar" id="inlineFormCustomSelect" v-model="tipoDocumento" :disabled="disabledTipo">                       
                        <option :value="tipodocumento.tipo" v-for="tipodocumento in documentoIdentidadGuia" v-bind:key="tipodocumento.tipo">
                            {{ tipodocumento.nombre }}
                        </option>
                    </b-select>
                </template>
            </b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                <template v-if="tipoDocumento != 0">
                    <b-input-group>
                        <b-form-input 
                            class="bordesYtexto input-buscar"
                            placeholder="Buscar Documento..." 
                            :maxlength="logitudDoc" 
                            v-model="receptor.numero" 
                            @change="pitcherReceiver(1)" 
                            :disabled="disabledFieldReceptor">
                        </b-form-input>
                        <template v-if="tipoDocumento !=6">
                            <!-- <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                                <b-button variant="warning" size="sm" class="mr-1 pb-0 pt-0" @click="enableFieldsReceptorCliente" :disabled="disabledFieldReceptor"><i class="fa fa-plus"></i></b-button>
                                <b-button variant="success" size="sm" class="pb-0 pt-0" @click="closeList()" title="ocultar lista" ><i class="fas fa-arrow-up"></i></b-button>
                            </b-input-group-text> -->
                        </template>                
                        </b-input-group>
                    <template v-if="cargandoreceptor">
                            <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                    </template>
                    <b-list-group v-if="listarec" class="searcher-field">
                        <!-- <b-list-group-item v-if="norec">No hay Receptores con ese número</b-list-group-item>                                  -->
                        <template v-for="(item, index) in listaReceptores">
                            <b-list-group-item :key="index" @click="setReceiver(item)" class="searcher-result">{{item.idReceptor + ' - ' + item.razonSocial}}</b-list-group-item>
                        </template>
                    </b-list-group> 
                    <b-list-group v-if="mostrardni" class="searcher-field">                                
                            <template >
                                <b-list-group-item  @click="setReceiverdni(listadni)" class="searcher-result">{{listadni.nombre + ' -- ' + listadni.dni}}</b-list-group-item>
                            </template> 
                        </b-list-group> 
                </template>
                <template v-else>
                    <b-form-input disabled></b-form-input>                          
                </template>         
            </b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="3" v-if="tipoDocumento != '0'">
                <template>
                    <b-form-input 
                    class="bordesYtexto input-buscar"
                    size="md" 
                    type="text" 
                    @input="pitcherReceiver(2)"
                    v-model="receptor.razonSocial" 
                    :value="receptor.razonSocial" 
                    :readonly="habilitado"
                    :disabled="disabledFieldReceptor"
                    placeholder="Razón Social">
                </b-form-input>
                </template>
            </b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2" v-else><b-input class="input-placedark input-dark" placeholder="Público en General" disabled></b-input></b-col>
            <b-col cols="12" sm="6"	md="8"	lg="8"	xl="4">
            <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12" v-if="tipoDocumento != '0'">
                    <template>
                        <b-input-group>
                        <b-form-input 
                            class="bordesYtexto input-buscar"
                            size="md" type="text" 
                            v-model="receptor.direccion" 
                            :value="receptor.direccion" 
                            :readonly="habilitado"
                            :disabled="disabledDireccionRemitente" 
                            placeholder="Dirección">
                        </b-form-input>
                        <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                            <button class="btn btn-warning btn-sm sinresultados" @click="changeDirection()">
                                <i class="fa fa-list"></i>
                            </button>
                        </b-input-group-text>
                    </b-input-group>
                    </template>
                    <template v-if="verDirecciones">
                        <template v-for="(item, index) in direcciones" class="buscarRuc">
                        <b-list-group-item
                                :key="index"
                                @click="setDirection(item)"
                                class="searcher-result"
                        >{{item.direccion}}</b-list-group-item>
                        </template>
                    </template>
                </b-col>   
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12" v-else><b-input class="input-placedark input-dark" placeholder="Direccion General" disabled></b-input></b-col>   
            </b-row>
            </b-col>
            <b-col v-if="tipodeguia != '0'" cols="12" sm="6"	md="4"	lg="4"	xl="1">
                <b-input-group>
                    <template v-if="seriesCargadas">
                        <b-button size="md" variant="secondary" outline-success>
                            Cargando Series... <i class="fa fa-spin fa-spinner"></i>
                        </b-button>
                    </template>
                    <template v-else>
                        <b-select class="bordesYtexto input-buscar" v-model="indexSerie">
                            <option v-for="(serie, index) in listaSeries" :value="index" :key="index">{{ serie }}</option>
                        </b-select>
                    </template>
                </b-input-group>  
            </b-col>
            <b-col v-if="tipodeguia == '0'">
                <b-input v-model="serieContingencia" placeholder="Serie"></b-input>
               
            </b-col>
            <b-col v-if="tipodeguia == '0'">
                 <b-input v-model="numeroContingencia" placeholder="Número"></b-input>
            </b-col>
        </b-row>
        <h5 v-if="motivotraslado == '02'"><p class="titulosPrimarios mt-2">Datos Proveedor</p></h5>
        <b-row v-if="motivotraslado == '02'">
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                <select :disabled="disabledTipo" class="custom-select mr-sm-2" v-model="tipoDocumentoProveedor">                       
                    <option :value="tipodocumento.tipo" v-for="tipodocumento in documentoIdentidadGuia" v-bind:key="tipodocumento.tipo">
                        {{ tipodocumento.nombre }}
                    </option>
                </select> 
            </b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                <template v-if="tipoDocumentoProveedor != 0">
                    <b-input-group>
                        <b-form-input 
                        class="bordesYtexto input-buscar"
                        placeholder="Buscar RUC..." 
                        :maxlength="logitudDoc" 
                        v-model="numeroDocumentoProveedor" 
                        @change="pitcherReceiver(3)" 
                        >
                    </b-form-input>
                    </b-input-group>
                    <template v-if="cargandoProveedor">
                            <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                    </template>
                    <b-list-group v-if="listarecProveedor" class="searcher-field">                                
                        <template v-for="(item, index) in listaReceptoresProveedores">
                            <b-list-group-item :key="index" @click="setReceiverProveedor(item)" class="searcher-result">{{item.idReceptor + ' - ' + item.razonSocial}}</b-list-group-item>
                        </template>
                    </b-list-group>  
                </template>
                <template v-else>
                    <b-form-input disabled></b-form-input>                          
                </template>
            </b-col>
            <b-col cols="3">
                <b-form-input 
                    class="bordesYtexto input-buscar"
                    size="md" type="text" 
                    v-model="denominacionProveedor" 
                    :value="denominacionProveedor" 
                    :readonly="habilitado"
                    maxlength="100"
                    placeholder="Razón Social">
                </b-form-input>
            </b-col>
            <b-col>
                <b-form-input 
                    class="bordesYtexto input-buscar"
                    size="md" type="text" 
                    v-model="direccionProveedor" 
                    :value="direccionProveedor" 
                    :readonly="habilitado" 
                    placeholder="Dirección">
                </b-form-input>
            </b-col>
        </b-row>
        <h5><p class="titulosPrimarios mt-2">Datos de la Ubicación</p></h5>
        <b-row>
            <b-col cols="12" sm="3"	md="3"	lg="3"	xl="2" >
                <b-input-group
                    >
                    <b-form-input
                        class="bordesYtexto input-buscar"
                        type="text"
                        v-model="ubigeoPartida"
                        required
                        maxlength="6"
                        :placeholder="placeholderUbigeoPartida">
                    </b-form-input>
                    <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                            <button class="btn btn-warning btn-sm sinresultados"  @click="modalUbigeoPartida=true">
                                <i class="fas fa-search"></i>
                            </button>
                    </b-input-group-text>
                </b-input-group>
            </b-col>
                <b-modal v-model="modalUbigeoPartida" title="Ubigeo de Partida" size="lg">
                    <b-row>
                        <b-col cols="4">
                            <template>
                                <h5> Selecciona Departamento </h5>
                                <b-select class="bordesYtexto input-buscar" v-model="departamentoSeleccionadoUbigeoOrigen">
                                    <option v-for="departamento in listDepartamento" :value="departamento.codDepartamento" :key="departamento.codDepartamento">{{ departamento.nombre }}</option>
                                </b-select>
                            </template>
                        </b-col>
                        <b-col cols="4">
                            <template>
                                <h5> Selecciona Provincia </h5>
                                <div v-if="!provOrigen">
                                    <b-form-input 
                                        type="text"
                                        disabled
                                        placeholder="Selecciona un Departamento...">
                                    </b-form-input>
                                </div>
                                <div v-else-if="provOrigenCargando">
                                    Cargando <i class="fa fa-spin fa-spinner"></i>
                                </div>
                                <div v-else>
                                    <select class="custom-select mr-sm-2" v-model="provinciaSeleccionadaUbigeoOrigen">
                                        <option v-for="provincia in listProvinceOrigen.Departments" :value="provincia.codProvincia" :key="provincia.codProvincia">{{ provincia.nombre }}</option>
                                    </select>
                                </div>
                            </template>
                        </b-col>
                        <b-col cols="4">
                             <template>
                                <h5> Selecciona Distrito </h5>
                                <div v-if="!distOrigen">
                                    <b-form-input 
                                        type="text"
                                        disabled
                                        placeholder="Selecciona una Provincia...">
                                    </b-form-input>
                                </div>
                                <div v-else-if="distOrigenCargando">
                                   Cargando <i class="fa fa-spin fa-spinner"></i>
                                </div>
                                <div v-else>
                                    <select class="custom-select mr-sm-2" v-model="distritoSeleccionadoUbigeoOrigen">
                                        <option v-for="distrito in listDistrictOrigen.Departments" :value="distrito" :key="distrito.codDistrito">{{ distrito.nombre }}</option>
                                    </select>
                                </div>
                            </template>
                        </b-col>
                    </b-row>
                </b-modal>   
            <template v-if="mostrarubigeoTexto">
                <b-col cols="12" sm="6"	md="7"	lg="8"	xl="4" class="pl-0 pr-1">
                <b-input-group size="md" :prepend="prependUbigeoOrigen"
                    label-for="input_direccionPartida"
                    :invalid-feedback="invalidFeedbackDireccionPartida"
                    :valid-feedback="validFeedbackDireccionPartida"
                    :state="stateDireccionPartida">
                    <b-form-input 
                        id="input_direccionPartida"
                        class="bordesYtexto input-buscar"
                        type="text"
                        v-model="direccionPartida"
                        required
                        maxlength="100"                    
                        placeholder="Dirección de Partida">
                    </b-form-input>
                        <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                          <button title="Cambiar a Selector" class="btn btn-warning btn-sm sinresultados" @click="cerrarresultados(1)"><i class="fas fa-list-ol"></i></button>
                        </b-input-group-text>
                </b-input-group>
            </b-col>
            </template>
            <template v-else>
               <b-col cols="12" sm="6"	md="7"	lg="8"	xl="4" class="pl-0">
                    <b-input-group>
                    <b-select v-if="mostrarUbigeo" class="bordesYtexto input-buscar" v-model="selectedDirUbigeo" >
                         <template v-for="(dirubigeo, index) in listUbigeo">
                            <option :value="index" :key="index" >{{dirubigeo.direccion}}</option>
                        </template>      
                    </b-select>
                    <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                        <button title="Cambiar a Escritura" class="btn btn-warning btn-sm sinresultados" @click="cerrarresultados(2)"><i class="fas fa-keyboard"></i></button>
                    </b-input-group-text>
                </b-input-group>
               </b-col>
            </template>          
            <b-col cols="12" sm="3"	md="3"	lg="3"	xl="2" >
                <b-input-group
                    label-for="input_ubigeoLlegada"
                    :invalid-feedback="invalidFeedbackUbigeoLlegada"
                    :valid-feedback="validFeedbackUbigeoLlegada"
                    :state="stateUbigeoLlegada">
                    <b-form-input
                        class="bordesYtexto input-buscar"
                        type="text"
                        v-model="ubigeoLlegada"
                        required
                        maxlength="6"
                        @keydown="handleKeyDown"
                        :state="stateUbigeoLlegada"
                        :placeholder="placeholderUbigeoLlegada">
                    </b-form-input>
                    <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                            <button class="btn btn-warning btn-sm sinresultados" @click="modalUbigeoDestino=true">
                                <i class="fas fa-search"></i>
                            </button>
                    </b-input-group-text>
                </b-input-group>
            </b-col>
                <b-modal v-model="modalUbigeoDestino" title="Ubigeo de Llegada" size="lg">
                    <b-row>
                        <b-col cols="4">
                            <template>
                                <h5> Selecciona Departamento </h5>
                                <select class="custom-select mr-sm-2" v-model="departamentoSeleccionadoUbigeoDestino">
                                    <option v-for="departamento in listDepartamento" :value="departamento.codDepartamento" :key="departamento.codDepartamento">{{ departamento.nombre }}</option>
                                </select>
                            </template>
                        </b-col>
                        <b-col cols="4">
                            <template>
                                <h5> Selecciona Provincia </h5>
                                <div v-if="!provDestino">
                                    <b-form-input 
                                        type="text"
                                        disabled
                                        placeholder="Selecciona un Departamento...">
                                    </b-form-input>
                                </div>
                                <div v-else-if="provDestinoCargando">
                                    Cargando <i class="fa fa-spin fa-spinner"></i>
                                </div>
                                <div v-else>
                                    <select class="custom-select mr-sm-2" v-model="provinciaSeleccionadaUbigeoDestino">
                                        <option v-for="provincia in listProvinceDestino.Departments" :value="provincia.codProvincia" :key="provincia.codProvincia">{{ provincia.nombre }}</option>
                                    </select>
                                </div>
                            </template>
                        </b-col>
                        <b-col cols="4">
                             <template>
                                <h5> Selecciona Distrito </h5>
                                <div v-if="!distDestino">
                                    <b-form-input 
                                        type="text"
                                        disabled
                                        placeholder="Selecciona un Departamento...">
                                    </b-form-input>
                                </div>
                                <div v-else-if="distDestinoCargando">
                                    Cargando <i class="fa fa-spin fa-spinner"></i>
                                </div>
                                <div v-else>
                                    <select class="custom-select mr-sm-2" v-model="distritoSeleccionadoUbigeoDestino">
                                        <option v-for="distrito in listDistrictDestino.Departments" :value="distrito" :key="distrito.codDistrito">{{ distrito.nombre }}</option>
                                    </select>
                                </div>
                            </template>
                        </b-col>
                    </b-row>
                </b-modal>
            <b-col cols="12" sm="6"	md="7"	lg="8"	xl="4" class="pl-0">
                <b-form-group
                    label-for="input_direccionLlegada"
                    :invalid-feedback="invalidFeedbackDireccionLlegada"
                    :state="stateDireccionLlegada">
                    <b-input-group size="md" :prepend="prependUbigeoDestino">
                        <b-form-input 
                            id="input_direccionLlegada"
                            class="bordesYtexto input-buscar"
                            type="text"
                            v-model="direccionLlegada"
                            required
                            maxlength="100"
                            @input="direccionLlegada = $event.toUpperCase()"
                            placeholder="Dirección de Llegada">
                        </b-form-input>
                         <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                            <button class="btn btn-warning btn-sm sinresultados" @click="changeDirectionUbigeo()">
                                <i class="fa fa-list"></i>
                            </button>
                        </b-input-group-text>
                    </b-input-group>
                    <template v-if="verDireccionesLlegada">
                        <template v-for="(item, index) in direcciones" class="buscarRuc">
                        <b-list-group-item
                                :key="index"
                                @click="setDirectionUbigeo(item)"
                                class="searcher-result"
                        >{{item.direccion}}</b-list-group-item>
                        </template>
                    </template>
                </b-form-group>
            </b-col>
        </b-row>
        </b-card>
        
        <!-- MOSTRAR U OCULTAR VEHICULOS modalidaddetraslado 01 = publico --> 
        <b-card style="border: #00b3b3 3px solid;">
            <h5 v-if="modalidaddetraslado=='01'"><p class="titulosPrimarios mt-2">Datos del Vehiculo Principal</p></h5>
        <b-row>
        <b-col v-if="modalidaddetraslado=='01'" cols="12" sm="6"	md="4"	lg="3"	xl="3">
            <b-select :disabled="disabledModalidadTraslado" class="bordesYtexto input-buscar" v-model="modalidaddetraslado">
                <option v-for="modalidad in modalidadTraslado" :value="modalidad.codigo" :key="modalidad.codigo">{{ modalidad.nombre }}</option>
            </b-select>
        </b-col>
        <b-col v-if="modalidaddetraslado=='01'"  cols="12" sm="6"	md="4"	lg="3"	xl="2">
            <b-select class="bordesYtexto input-buscar" :disabled="disabledModalidadTraslado" v-model="tipoDocumentoTransportista">
                <option 
                    :value="tipodocumento.tipo" 
                    v-for="tipodocumento in documentoIdentidadGuia" 
                    v-bind:key="tipodocumento.tipo">
                    {{tipodocumento.nombre}}
                </option>
            </b-select>
        </b-col>
        <b-col v-if="modalidaddetraslado=='01'" cols="12" sm="6"	md="4"	lg="3"	xl="3">
                <template v-if="tipoDocumentoTransportista != 0">
                        <b-form-group
                            label-for="input_numeroRucTransportista"
                            :invalid-feedback="invalidFeedbackNumeroRucTransportista"
                            :valid-feedback="validFeedbackNumeroRucTransportista"
                            :state="stateNumeroRucTransportista">
                            <b-form-input
                                class="bordesYtexto input-buscar"
                                type="text"
                                v-model="numeroRucTransportista"
                                required
                                :state="stateNumeroRucTransportista"
                                @change="reciverTrasportista(1)" 
                                placeholder="Buscar RUC Transportista...">
                            </b-form-input>
                        </b-form-group>
                        <template v-if="cargandoreceptorTransportista">
                                <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                        </template>
                        <b-list-group v-if="listarecTransportista" class="searcher-field">
                            <b-list-group-item v-if="norecTransportista">No hay Receptores con ese número</b-list-group-item>                                 
                            <template v-for="(item, index) in listaTransportista">
                                <b-list-group-item :key="index" @click="setReceiverTransportista(item)" class="searcher-result">{{item.idReceptor + ' - ' + item.razonSocial}}</b-list-group-item>
                            </template>
                        </b-list-group>  
                </template>
            </b-col>
            <b-col v-if="modalidaddetraslado=='01'" cols="12" sm="6"	md="4"	lg="3"	xl="4">
                <b-form-group
                        label-for="input_denominacionTransportista"
                        >
                        <b-input-group size="md">
                            <b-form-input 
                               placeholder="Razon social"
                                id="input_denominacionTransportista"
                                class="bordesYtexto input-buscar"
                                type="text"
                                v-model="denominacionTransportista"
                                required
                                @input="denominacionTransportista = $event.toUpperCase()"
                                :value="denominacionTransportista"
                                 @change="getReceiversRazSocial(2)"
                                >
                            </b-form-input>
                        </b-input-group>
                    </b-form-group>
            </b-col>
        </b-row>
        <b-row class="mb-3">
            <template v-if="motivotraslado == '01' && modalidaddetraslado == '01'">
                <b-col cols="12" sm="6"	md="4"	lg="3"	xl="3">
                    <div class="campo-con-label">
                        <label>Fecha Entrega Bienes Transportista</label>

                        <datepicker 
                            class="bordesYtexto"
                            v-model="fechaEntregaBienesTransportista" 
                            :format="customFormatter" 
                            :language="es" 
                            :bootstrap-styling="true" 
                            :disabledDates="diasnopermitidosBienesTrans" 
                            :placeholder="currentdateTransporte">
                        </datepicker>
                    </div>
                </b-col>
            </template>
        </b-row>
        <b-row>
        <b-col cols="12">
        <h5 v-if="modalidaddetraslado=='02'"><p class="titulosPrimarios mt-2">Datos del Vehiculo Principal</p></h5>
        <b-row>
            <b-col  v-if="modalidaddetraslado=='02'" cols="12" sm="6"	md="4"	lg="4"	xl="2">
                <b-select :disabled="disabledModalidadTraslado" class="bordesYtexto input-buscar" v-model="modalidaddetraslado">
                        <option v-for="modalidad in modalidadTraslado" :value="modalidad.codigo" :key="modalidad.codigo">{{ modalidad.nombre }}</option>
                </b-select>
            </b-col>
            <b-col cols="12" sm="6"	md="5"	lg="3"	xl="2">
                <div v-if="modalidaddetraslado=='02'" class="texto-arriba">Seleccionar Tipo Vehículo</div>
                <b-select v-if="modalidaddetraslado=='02'" class="bordesYtexto input-buscar" v-model="tipoVehiculo">
                    <option 
                        :value="tipoVehiculo.codigo" 
                        v-for="tipoVehiculo in tipoVehiculoOpcion" 
                        v-bind:key="tipoVehiculo.codigo">
                        {{tipoVehiculo.nombre}}
                    </option>
                </b-select>
            </b-col>
            <b-col v-if="modalidaddetraslado=='02'" cols="12" sm="6"	md="5"	lg="4"	xl="2">
                <b-form-group
                    :state="stateCirculacionVehiculoPlaca"
                    :invalid-feedback="invalidFeedbackCirculacionVehiculoPlaca">
                <b-input-group> 
                    <b-form-input
                        class="bordesYtexto input-buscar"
                        :state="stateCirculacionVehiculoPlaca"
                        maxlength="7"
                        placeholder="Buscar Placa..."
                        v-model="placaVehiculo"
                        @change="pitcherReceiverRemitente(3)"
                        @input="mayus()"
                        @keydown="validaSoloAlfaNum"
                        @paste="limpiarTextoPegado">
                    </b-form-input>
                    <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                            <b-button
                                v-b-tooltip.hover title="Clic para mostrar listado"
                                @click="listaDeVehiculos()"
                                variant="warning"
                                class="pb-0 pt-0 pl-1 pr-1"
                                size="sm">
                                <i class="fas fa-search"></i>
                            </b-button>
                        <template v-if="listaVehiculo">
                            <b-button v-if="listaVehiculos.length > 0"
                                v-b-tooltip.hover title="Cerrar Lista"
                                variant="warning"
                                size="sm"
                                class="ml-1 pt-0 pb-0 pl-1 pr-1" 
                                @click="closeListVehiculo()" >
                                <i class="fas fa-arrow-up"></i>
                            </b-button>
                        </template>
                    </b-input-group-text>
                </b-input-group>
                </b-form-group>
                <b-list-group v-if="listaVehiculo" class="searcher-fieldplaca">
                    <table v-if="listaVehiculos.length > 0" class="searcher-result3">
                        <tr class="centrarTitulo tablaborde">
                        <th style="width:16%;">Placa</th>
                         <!-- <th style="width:25%;">Código/Alias</th> -->
                        <th style="width:16%;">Certificado de Habilitación vehicular</th>
                        <th style="width:16%;">Cod. Entidad</th>
                        <th style="width:16%;">Nro. Autorización</th>
                        </tr>
                    </table>
                    <template v-for="(item, index) in listaVehiculos">
                        <table  
                            @click="setReceiverVehiculo(item)" 
                            class="searcher-result2" 
                            :key="index">  
                            <tr>
                            <td style="width:16%;" class="tablaborde centrarTitulo">{{item.placa}}</td>
                            <!-- <td style="width:23%;" class="tablaborde ">{{item.codigo}}</td> -->
                            <td style="width:16%;" class="tablaborde ">{{item.nroCirculacionMTC}}</td>
                            <td style="width:16%; text-align:center" class="tablaborde ">{{item.idEntidad}}</td>
                            <td style="width:16%;" class="tablaborde ">{{item.numeroPermiso}}</td>
                            </tr>
                        </table>
                    </template>
                </b-list-group> 
            </b-col>
            <b-col cols="12" sm="6"	md="5"	lg="4"	xl="2" v-if="modalidaddetraslado=='02'">
                <template>
                    <div v-if="!bloquearCampoVehiPrincipal" class="texto-arriba">Opcional</div>
                        <b-form-input 
                            :disabled="bloquearCampoVehiPrincipal"
                            class="bordesYtexto input-buscar"
                            v-model="numCirculacionVehiculo"
                            placeholder="Certificado de Habilitación Vehicular - TUCE">
                        </b-form-input> 
                </template>
            </b-col>
            <b-col cols="12" sm="6"	md="5"	lg="5"	xl="3" v-if="modalidaddetraslado=='02'">
            <div class="texto-arriba">Vehículo Secundario (Opcional hasta 2)</div>
            <b-form-group
                :state="stateCirculacionVehiculoPlacaSecun"
                :invalid-feedback="invalidFeedbackCirculacionVehiculoPlacaSecun">
                <b-input-group>
                <b-form-input
                    class="bordesYtexto input-buscar"
                    maxlength="7"
                    :state="stateCirculacionVehiculoPlacaSecun"
                    :disabled="bloquearCampoVehiSecundario"
                    placeholder="Buscar Placa..."
                    v-model="placaVehiculoSecundario"
                    @change="getReceiverVehiculosSecundarios()"
                    @input="mayus()"
                    @keydown="validaSoloAlfaNum"
                    @paste="limpiarTextoPegadoSecundario">
                </b-form-input>
                <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                    <b-button
                        :disabled="bloquearCampoVehiSecundario"
                        v-b-tooltip.hover title="Clic para mostrar listado"
                        @click="listaDeVehiculosSecundarios()"
                        variant="warning"
                        class="pb-0 pt-0 pl-1 pr-1"
                        size="sm">
                        <i class="fas fa-search"></i>
                    </b-button>
                    <template v-if="listaVehiculoSecundario">
                    <b-button v-if="listaVehiculosSecundarios.length > 0"
                        v-b-tooltip.hover title="Cerrar Lista"
                        variant="warning"
                        size="sm"
                        class="ml-1 pt-0 pb-0 pl-1 pr-1" 
                        @click="closeListVehiculoSecundario()" >
                        <i class="fas fa-arrow-up"></i>
                    </b-button>
                    </template>
                </b-input-group-text>
            </b-input-group>
            <b-list-group v-if="listaVehiculoSecundario" class="searcher-fieldplaca">
                    <table v-if="listaVehiculosSecundarios.length > 0" class="searcher-result3">
                        <tr class="centrarTitulo tablaborde">
                        <th style="width:16%;">Placa</th>
                        <th style="width:16%;">Certificado de Habilitación vehicular</th>
                        <th style="width:16%;">Cod. Entidad</th>
                        <th style="width:16%;">Nro. Autorización</th>
                        </tr>
                    </table>
                    <template v-for="(item, index) in listaVehiculos">
                        <table  
                            @click="setReceiverVehiculoSecundario(item)" 
                            class="searcher-result2" 
                            :key="index">  
                            <tr>
                            <td style="width:16%;" class="tablaborde centrarTitulo">{{item.placa}}</td>
                            <td style="width:16%;" class="tablaborde ">{{item.nroCirculacionMTC}}</td>
                            <td style="width:16%; text-align:center" class="tablaborde ">{{item.idEntidad}}</td>
                            <td style="width:16%;" class="tablaborde ">{{item.numeroPermiso}}</td>
                            </tr>
                        </table>
                    </template>
            </b-list-group>
            <template v-if="placaVehiculo !=''">
                <p class="mb-0" v-if="placaVehiculo == placaVehiculoSecundario" style="font-size:12px;color:red">Placa debe ser diferente al principal</p>
            </template>
            </b-form-group>
            </b-col>
            <b-col v-if="modalidaddetraslado=='02'" cols="12" sm="6" md="4" lg="1" xl="1">
            <template v-if="!botonEditar">
                <b-button
                    v-if="validarCamposVehiculo()"
                    size="sm"
                    variant="warning"
                    @click="guardarVehiculoSecundario()">
                    Agregar
                </b-button>
                <b-button 
                    v-else
                    size="sm"
                    variant="warning"
                    disabled
                    >
                    Agregar
                </b-button>
            </template>
            <template v-else>
                <b-button v-if="validarPlacaSecu()"
                    size="sm"
                    variant="warning"
                    @click="editarVehiculo()">
                        Editar
                </b-button>
                <b-button
                    v-else
                    size="sm"
                    variant="warning"
                    disabled>
                        Editar
                </b-button>
            </template>
            </b-col> 
        </b-row>
        </b-col>
        </b-row>
        <b-row v-if="modalidaddetraslado=='02' && recibeVehiculoSecundario.length>0" >
            <b-col cols="12" sm="6"	md="4" lg="4" xl="8"></b-col>
            <b-col cols="12" sm="6"	md="4" lg="4" xl="3">
                <b-table class="mt-1"
                        small
                        responsive
                        outlined
                        bordered
                        :items="recibeVehiculoSecundario"
                        :fields="recibeVehiculos_Secundario">
                    <template slot="acciones" slot-scope="row" >
                        <b-button 
                            size="sm"
                            variant="ligth"
                            @click="editarVehiculoSecundario(row.index, row.item)">
                            <i class="fa fa-edit text-primary"></i>
                        </b-button>
                        <b-button 
                            size="sm"
                            variant="ligth"
                            @click="eliminarVehiculoSecundario(row.index)">
                            <i class="fa fa-trash text-danger"></i>
                        </b-button>
                    </template>
                </b-table>
            </b-col>
        </b-row>
        <!-- <h5 v-if="modalidaddetraslado == '01'"><p class="titulosPrimarios">Datos Conductor <b style="color:red">(Opcional)</b></p></h5>  -->
        <h5 v-if="tipoVehiculo == '02'"><p class="titulosPrimarios">Datos Conductor 
            <!-- <b v-if="tipoVehiculo =='01'" style="color:red">(Opcional)</b>  -->
            <b v-if="tipoVehiculo =='02'" style="color:red">(Obligatorio)</b></p>
            <b v-if="modalidaddetraslado == '01'" style="color:red">(Opcional)</b></p>
            <!-- <b v-else-if="tipoVehiculo  =='03'"></b></p> -->
        </h5>
        <h5 v-if="modalidaddetraslado == '01'"><p class="titulosPrimarios">Datos Conductor 
            <b v-if="modalidaddetraslado == '01'" style="color:red">(Opcional)</b></p>
        </h5>
        <b-row v-if="tipoVehiculo == '02' || modalidaddetraslado == '01'">
            <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                <b-select class="bordesYtexto input-buscar" v-model="tipoDocConductor" :disabled="bloquearCampoConductor">
                    <option 
                    :value="tipodocumento.tipo" 
                    v-for="tipodocumento in documentoIdentidadGuia" 
                    v-bind:key="tipodocumento.tipo">
                    {{tipodocumento.nombre}}
                    </option>
                </b-select>
            </b-col>
            <b-col cols="12" sm="6"	md="4" lg="4" xl="3">
                        <b-input-group>
                            <b-form-input 
                                class="bordesYtexto input-buscar"
                                :disabled="bloquearCampoConductor"
                                placeholder="Buscar Documento..."
                                type="text"
                                v-model="numDoc"
                                @keydown="handleKeyDown"
                                @change="pitcherReceiverRemitente(2)">
                            </b-form-input>
                            <b-input-group-text class="bordesYtexto input-buscar" v-if="conductoresAsociados.length > 0" slot="prepend">
                                <b-button
                                    :disabled="bloquearCampoConductor"
                                    v-b-tooltip.hover title="Ver lista de conductores asociados a la placa ingresada"
                                    variant="warning"
                                    size="sm"
                                    class="pt-0 pb-0 pl-1 pr-1"
                                    @click="seleccionarConductorAsociado()">
                                    <i class="fa fa-eye" aria-hidden="true"></i>
                                </b-button>
                                <b-button v-if="listaConductorAsociado"
                                        v-b-tooltip.hover title="Cerrar Lista"
                                        variant="warning"
                                        size="sm"
                                        class="ml-1 pt-0 pb-0 pl-1 pr-1" 
                                        @click="closeListConductorAsociado()" >
                                        <i class="fas fa-arrow-up"></i>
                                    </b-button>
                            </b-input-group-text>
                            <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                                <b-button
                                    :disabled="bloquearCampoConductor"
                                    v-b-tooltip.hover title="Clic para mostrar listado"
                                    variant="warning"
                                    size="sm"
                                    class="pb-0 pt-0 pl-1 pr-1" 
                                    @click="listarConductores()">
                                    <i class="fas fa-search"></i>
                                </b-button>
                                <template v-if="listaConductor">
                                    <b-button v-if="listaConductores.length > 0"
                                        v-b-tooltip.hover title="Cerrar Lista"
                                        variant="warning"
                                        size="sm"
                                        class="ml-1 pt-0 pb-0 pl-1 pr-1" 
                                        @click="closeListConductor()" >
                                        <i class="fas fa-arrow-up"></i>
                                    </b-button>
                                </template>
                            </b-input-group-text>
                        </b-input-group>
                        <template>
                            <b-list-group v-if="listaConductor" class="searcher-fieldconductor">
                                <table v-if="listaConductores.length > 0" class="searcher-result3">
                                    <tr class="centrarTitulo tablaborde">
                                    <th style="width:20%;">Documento</th>
                                    <th style="width:20%;">Alias</th>
                                    <th style="width:20%;">Nombres</th>
                                    <th style="width:20%;">Apellidos</th>
                                    <th style="width:20%;">Nro. Licencia</th>
                                    </tr>
                                </table>
                                <template v-for="(item, index) in listaConductores">
                                <table  
                                    @click="setReceiverConductor(item)" 
                                    class="searcher-result2" 
                                    :key="index"> 
                                    <tr>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.nroDocumento}}</td>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.codigo}}</td>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.nombres}}</td>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.apellidos}}</td>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.nroLicencia}}</td>
                                    </tr>
                                </table>
                                </template>
                            </b-list-group>
                        </template>
                        <template>
                            <b-list-group v-if="listaConductorAsociado" class="searcher-fieldconductor">
                                <table v-if="conductoresAsociados.length > 0" class="searcher-resultAsociados">
                                    <tr class="centrarTitulo tablaborde">
                                    <th style="width:20%;">Documento</th>
                                    <th style="width:20%;">Alias</th>
                                    <th style="width:20%;">Nombres</th>
                                    <th style="width:20%;">Apellidos</th>
                                    <th style="width:20%;">Nro. Licencia</th>
                                    </tr>
                                </table>
                                <template v-for="(item, index) in conductoresAsociados">
                                <table  
                                    @click="setReceiverConductorAsociado(item)" 
                                    class="searcher-result2" 
                                    :key="index"> 
                                    <tr>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.nroDocumento}}</td>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.codigo}}</td>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.nombres}}</td>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.apellidos}}</td>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.nroLicencia}}</td>
                                    </tr>
                                </table>
                                </template>
                            </b-list-group>
                        </template>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-form-input
                        class="bordesYtexto input-buscar"
                        :disabled="bloquearCampoConductor"
                        placeholder="Buscar Nombre..."
                        type="text"
                        v-model="nombreConductor"
                        @change="getReceiverConductorNombre()">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-form-input
                        class="bordesYtexto input-buscar"
                        :disabled="bloquearCampoConductor"
                        placeholder="Apellidos"
                        type="text"
                        v-model="apellidoConductor">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-form-input
                        class="bordesYtexto input-buscar"
                        :disabled="bloquearCampoConductor"
                        placeholder="Licencia"
                        v-model="numLicencia">
                        </b-form-input>
                    </b-col>    
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="1">
                        <template v-if="!botonEditarConductor">
                        <b-button 
                            v-if="validarConductor()"
                            size="sm"
                            style="width:100%"
                            variant="warning" 
                            @click="guardarConductor()">
                            Agregar
                        </b-button>
                        <b-button
                            v-else
                            size="sm"
                            style="width:100%"
                            disabled
                            variant="warning">
                            Agregar
                        </b-button>
                        </template>
                        <template v-else>
                            <b-button 
                            style="width:100%"
                            variant="warning"
                            @click="editarConductor()">
                            Editar
                            </b-button>
                        </template>
                    </b-col>
        </b-row>
        <b-row v-if="tipoVehiculo =='02' || modalidaddetraslado == '01'">
            <b-col  cols="12" sm="6" md="12" lg="12" xl="10">
                <b-table class="mt-4"
                    small
                    responsive
                    outlined
                    fixed
                    bordered
                    :items="recibeConductorSecundario"
                    :fields="recibeConductor_Secundario">
                        <template slot="tipoConductor" slot-scope="row">
                            <span v-if="row.item.tipoConductor == 'Principal'">
                                 <b><p class="text-danger">{{row.item.tipoConductor}}</p></b>
                            </span>
                            <span v-else-if="row.item.tipoConductor == 'Secundario'">
                                 <b><p class="text-primary">{{row.item.tipoConductor}}</p></b>
                            </span>
                        </template>
                        <template slot="tipoDocumentoConductor" slot-scope="row">
                           <div v-if="row.item.tipoDocumentoConductor == '1'">DNI</div>
                           <div v-if="row.item.tipoDocumentoConductor == '6'">RUC</div>
                           <div v-if="row.item.tipoDocumentoConductor == '4'">Carnet de Extranjeria</div>
                           <div v-if="row.item.tipoDocumentoConductor == '7'">Pasaporte</div>
                           <div v-if="row.item.tipoDocumentoConductor == 'A'">Cedula Diplomatica de Identidad</div>
                           <div v-if="row.item.tipoDocumentoConductor == 'B'">DOC.IDENT.PAIS.RESIDENCIA-NO.D</div>
                           <div v-if="row.item.tipoDocumentoConductor == 'C'">Doc Trib PP.NN</div>
                           <div v-if="row.item.tipoDocumentoConductor == 'D'">Doc Trib PP. JJ</div>
                           <div v-if="row.item.tipoDocumentoConductor == 'E'">TAM- Tarjeta Andina de Migración</div>
                        </template>
                        <template slot="acciones" slot-scope="row" >
                            <b-button 
                            size="sm"
                            variant="ligth"
                            @click="editarDatosConductor(row.index, row.item)">
                            <i class="fa fa-edit text-primary"></i>
                            </b-button>
                            <!-- (PARA NO ELIMINAR EL PRIMER CONDUCTOR)v-if="row.item.tipoConductor !='Principal'" -->
                            <b-button 
                            size="sm"
                            variant="ligth"
                            @click="eliminarConductor(row.index)">
                            <i class="fa fa-trash text-danger"></i>
                            </b-button>
                        </template>
                        </b-table>
                    </b-col>
        </b-row>
    </b-card>
    <b-card style="border: #00b3b3 3px solid;">
        <h5><p class="titulosPrimarios">Datos de la Guía de Remisión</p></h5>
        <b-row> 
            <b-col>
                <b-row>
                    <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                        <b-form-group>
                            <b-form-input
                                class="bordesYtexto input-buscar"
                                type="text"
                                v-model="pesoBruto"
                                @keydown="validaPeso"
                                placeholder="Peso Bruto(KG)">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" lg="3" xl="2">
                        <div class="campo-con-label">
                            <label>Fecha Inicio Traslado</label>

                            <datepicker
                                class="bordesYtexto"
                                v-model="fechaInicioTraslado"
                                :format="customFormatter"
                                :language="es"
                                :bootstrap-styling="true"
                                :disabledDates="diasFechaTrasporte"
                                :placeholder="currentdateTransporte">
                            </datepicker>
                        </div>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                        <b-form-input
                            class="bordesYtexto input-buscar"
                            v-model="descripcionMotivoTraslado"
                            type="text"
                            required
                            placeholder="Descripcion ó Motivo de Traslado">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                        <b-form-input
                            class="bordesYtexto input-buscar"
                            v-model="numeroContenedor"
                            type="text"
                            required
                            placeholder="Nro. Contenedor">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" sm="6"	md="12"	lg="12"	xl="4">
                        <b-form-input
                            class="bordesYtexto input-buscar"
                            v-model="observaciones"
                            type="text"
                            required
                            placeholder="Observaciones">
                        </b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="4">
                        <b-form-textarea
                            class="bordesYtexto input-buscar"
                            v-model="informacionAdicional"
                            placeholder="Información adicional"
                            rows="3"
                            max-rows="6"
                            maxlength="500"
                    ></b-form-textarea> 
                    </b-col>
                    <template v-if="motivotraslado == '08'">
                    <b-col cols="2">
                        <b-button v-if="motivotraslado == '08'" v-b-modal.docRelacionados2><i class="fa fa-plus"></i> Documentos Relacionados</b-button> 
                    </b-col>
                    <b-modal id="docRelacionados2" title="Guia de remision" size="lg">
                        <b-row>
                            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="4">
                                <select class="custom-select mr-sm-2" v-model="codigoRelacionadoImportacion">
                                    <option v-for="tipo in listCodRelacionadoPublico" :value="tipo.codigo" :key="tipo.codigo">{{ tipo.descripcion }}</option>
                                </select>
                            </b-col>
                            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="4">
                                    <b-form-group
                                        v-if="codigoRelacionadoImportacion == '01'"
                                        label-for="input_numero"
                                        :invalid-feedback="invalidFeedbackDam"
                                        :valid-feedback="validFeedbackDam"
                                        @keyup.enter="addRelacionado"  
                                        required
                                        :state="stateDam">
                                        <b-input-group size="md">
                                            <b-form-input :value="numeroRelacionado" maxlength="18" v-model="numeroRelacionado" class="form-control" type="text" id="input_numero" :state="state" placeholder="0000-00-000-000000"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                    <b-form-group
                                        v-else
                                        label-for="input_numero"
                                        :invalid-feedback="invalidFeedbackManifiesto"
                                        :valid-feedback="validFeedbackManifiesto"
                                        @keyup.enter="addRelacionado"  
                                        required
                                        :state="stateManifiesto">
                                        <b-input-group size="md">
                                            <b-form-input :value="numeroRelacionado" maxlength="13" v-model="numeroRelacionado" class="form-control" type="text" id="input_numero" :state="state" placeholder="000-0000-0000"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                                <template v-if="codigoRelacionadoImportacion == '01'">
                                    <button v-if="stateDam" class="btn btn-success " @click="addRelacionado"><i class="fa fa-plus"> Agregar</i></button>
                                    <button v-else class="btn btn-secondary " disabled><i class="fa fa-plus"> Agregar</i></button>
                                </template>
                                <template v-else>
                                    <button v-if="stateManifiesto" class="btn btn-success " @click="addRelacionado"><i class="fa fa-plus"> Agregar</i></button>
                                    <button v-else class="btn btn-secondary " disabled><i class="fa fa-plus"> Agregar</i></button>
                                </template>
                            </b-col>
                        </b-row>
                        <hr>
                        <table class="table table-boreder">
                            <thead>
                                <tr>
                                    <th>Codigo</th>
                                    <th>Numero</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in documentosRelacionadosLocal" :key="index">
                                    <td>{{ item.descripcion }}</td>
                                    <td>{{ item.numero }}</td>
                                    <td>                            
                                        <button class="btn btn-sm btn-group btn-outline-danger" @click.prevent="deleteRelacionado(index)"><i class="fa fa-trash danger"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <hr>        
                    </b-modal>
                    <b-col cols="2">
                        <b-form-group
                        label-for="input_ubigeoLlegada"
                        :invalid-feedback="invalidFeedbackNumeroBultos"
                        :valid-feedback="validFeedbackNumeroBultos"
                        :state="stateNumeroBultos">
                        <b-form-input
                            class="bordesYtexto input-buscar"
                            type="number"
                            v-model="numeroBultos"
                            required
                            :state="stateNumeroBultos"
                            placeholder="Nro. Bultos">
                        </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="2">
                        <b-form-group
                        label-for="input_codigoPuerto"
                        :invalid-feedback="invalidFeedbackCodigoPuerto"
                        :valid-feedback="validFeedbackCodigoPuerto"
                        :state="stateCodigoPuerto">
                        <b-form-input
                            class="bordesYtexto input-buscar"
                            type="text"
                            v-model="codigoPuerto"
                            required
                            :state="stateCodigoPuerto"
                            placeholder="Cod. Puerto">
                        </b-form-input>
                        </b-form-group>
                    </b-col>
                    </template>
                </b-row>
            </b-col>
        </b-row>
    </b-card>
    <b-card style="border: #00b3b3 3px solid;">
        <h5 ><p class="titulosPrimarios">Items</p></h5>
        <b-row>              
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="1">
                 <b-form-group
                        label-for="input_pesoBruto"
                        >
                        <b-form-input
                            class="bordesYtexto input-buscar"
                            type="text"
                            v-model="cantidad"
                            required
                            @keyup.enter="addItem"
                            @keydown="numeroPunto"
                            min="0.0" step="0.01"
                            placeholder="Cant.">
                        </b-form-input>
                 </b-form-group>
            </b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="1">
                <b-form-input
                    v-model="codigoItem"
                    type="text"
                    required
                    class="bordesYtexto input-buscar"
                    @input="getReceiversCodigoInterno"
                    placeholder="C. Int.">
                </b-form-input>
                <template v-if="cargandoCodigoInterno">
                        <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                    </template>
                    <b-list-group v-if="listCodigoInterno" class="searcher-field">
                    <b-list-group-item v-if="noCodigoInterno">No hay Productos que coincidan</b-list-group-item>                                 
                    <template v-for="(item, index) in listaCodigoInterno">
                        <b-list-group-item :key="index" @click="setReceiverCodigoInterno(item)" class="searcher-result">{{item.codigo + ' - ' + item.descripcion}}</b-list-group-item>
                    </template>
                </b-list-group>
            </b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="1">
                <b-form-input
                    v-model="codigoSunat"
                    type="text"
                    required
                    class="bordesYtexto input-buscar"
                    placeholder="C. SUNAT.">
                </b-form-input>
            </b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="1">
                <b-form-input
                    v-model="codigoBarras"
                    type="text"
                    required
                    class="bordesYtexto input-buscar"
                    @change="getReceiversCodigoBarras"
                    placeholder="C. Barras.">
                </b-form-input>
            </b-col>
             <b-col cols="12" sm="6"	md="4"	lg="4"	xl="1">
               <b-select class="bordesYtexto input-buscar" v-model="unidadMedidaCantidad">                       
                    <option :value="unidad.codigo" v-for="unidad in unidades" v-bind:key="unidad.id">
                        {{ unidad.descripcion }}
                    </option>
                </b-select> 
            </b-col>
            <!-- <b-col cols="12" sm="6"	md="4"	lg="4"	xl="1">
                <b-form-input
                    v-model="pesoProducto"
                    type="number"
                    class="bordesYtexto input-buscar"
                    placeholder="Peso KG">
                </b-form-input>
            </b-col> -->
            <b-col cols="12" sm="12"	md="4"	lg="4"	xl="6">
                <b-form-group label-for="input_pesoBruto">
                    <b-input-group>
                        <b-form-input 
                            placeholder="Descripcion... (500 caracteres)" 
                            @keyup.enter='search()'
                            maxlength="500" 
                            required
                            class="bordesYtexto input-buscar"
                            v-model="descripcion" 
                            @input="getReceiversDescription">
                        </b-form-input>
                        <b-input-group-text  slot="prepend" class="pt-0 pb-0 bordesYtexto input-buscar">
                            {{contadorDescripcion}}
                        </b-input-group-text>
                    </b-input-group>
                </b-form-group>
                <template v-if="cargandoDescription">
                                <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                </template>
                <b-list-group v-if="listades" class="searcher-field-description">
                    <b-list-group-item v-if="nodescription">No hay productos con ese número</b-list-group-item>                                 
                    <template v-for="(item, index) in listaDescription">
                        <b-list-group-item :key="index" @click="setReceiverDescription(item)" class="searcher-result">{{item.codigo + ' - ' + item.descripcion}}</b-list-group-item>
                    </template>
                </b-list-group> 
            </b-col>        
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="1">
                <b-form-checkbox v-model="adicionalesItemsGuia" @click="!adicionalesItemsGuia">
                        Adicionales
                </b-form-checkbox>
            </b-col>
        </b-row>
        <template v-if="adicionalesItemsGuia">
            <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                    <b-alert show>
                        <b-row>
                            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="4">
                                <b-form-input
                                    v-model="lote"
                                    type="text"
                                    required
                                    class="bordesYtexto input-buscar"
                                    placeholder="Lote">
                                </b-form-input>
                            </b-col>
                            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="4">
                                <b-form-input
                                    v-model="peso"
                                    type="text"
                                    required
                                    class="bordesYtexto input-buscar"
                                    placeholder="Peso">
                                </b-form-input>
                            </b-col>
                            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="4">
                                <datepicker 
                                    class="bordesYtexto input-buscar"
                                    v-model="fvencimientoItem" 
                                    :format="customFormatter" 
                                    :language="es" 
                                    :bootstrap-styling="true" 
                                    :disabledDates="diasnopermitidos" 
                                    placeholder="Fecha de Vencimiento">
                                </datepicker>
                            </b-col>
                        </b-row>
                    </b-alert>
                </b-col>
            </b-row>
        </template>
        <b-row class="text-center">
           <b-col cols="9">
                <template v-if="!setUpdateItem">
                    <button style="width: 325px" class="btn btn-primary" v-if="validateFields()" @click="addItem"><i class="fa fa-plus"></i> Agregar</button>
                    <button style="width: 325px" class="btn btn-secondary" disabled v-else><i class="fa fa-plus"></i> Agregar</button>
                </template>
                <template v-else>
                    <button class="btn btn-warning" @click="executeUpdate()"><i class="fa fa-plus"></i> Actualizar</button>
                </template>
            </b-col>
            <b-col cols="2">
               <div class="upload-btn-wrapper">
                    <b-button class="estilo"><i class="fas fa-upload"></i> Items</b-button>
                    <input  type="file" @change="onChange" name="myfile" />
                </div>
                <xlsx-read :file="file">                       
                    <xlsx-json>
                    <template #default="{collection}">
                    <div style="display:none;">
                    {{ coleccion=collection }}
                    </div>
                    </template>
                    </xlsx-json>
                </xlsx-read>
            <import :itemsEX="itemsEX" :action="action" @totalitems="totalitems"></import>
            </b-col>
        </b-row>
        <b-table 
            responsive
            :small="small"
            :striped="striped"
            :outlined="outlined"
            :items="items"
            :fields="items_fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            >
            <template slot="index" slot-scope="row">{{ row.index +1 }}</template>
            <template slot="descripcion" slot-scope="row">
                <b-form-textarea
                id="textarea"
                v-model="row.item.descripcion"
                placeholder="Enter something..."
                rows="3"
                max-rows="6"
                ></b-form-textarea>
            </template>
            <!-- <template slot="pesoProducto" slot-scope="row">
                    {{row.item.codigoItem}}
                </template> -->
            <template slot="acciones" slot-scope="row">
                <b-row>
                    <button class="btn btn-sm btn-group btn-outline-primary acciones-espacio" @click.prevent="updateItem(row.index, row.item)"><i class="fa fa-edit primary"></i></button>
                    <button class="btn btn-sm btn-group btn-outline-danger" @click.prevent="deleteItem(row.index)"><i class="fa fa-trash danger"></i></button>
                </b-row>
            </template>
        </b-table>
        </b-card>
            <div class="row">
                <div class="col-md-6"></div>
                <div class="col-md-4 text-right">
                    <template v-if="validateGuide()">
                        <button v-if="!cargandoemision" class="btn btn-primary" @click.prevent="sendPreviw(true)"><i class="fa fa-search"></i> Previsualizar</button>
                        <button v-else class="btn btn-seconday"><i class="fa fa-spin fa-spinner"></i> Emitiendo</button>
                    </template>
                    <template v-else>
                        <button class="btn btn-secondary" disabled><i class="fa fa-send"></i> Previsualizar</button>
                    </template>
                </div>
            </div>
            <template v-if="postEmision">
                <vista-post-emison :idDocumentPreview="idDocumentPreview" :tipoDocPreview="tipoDocPreview"></vista-post-emison>
            </template>  
                        <b-modal scrollable title="Busqueda de productos" size="lg" v-model="searchItems">
            <div v-if="mostrarListaProduc">
                <div align="center" class="mb-5">
                    <h3><i class="fas fa-spin fa-spinner"></i><strong>Cargando...</strong></h3> 
                </div>
            </div>
            <div v-else>
                <b-table :items="ListProductos" :fields="List_Productos">
                <template slot="cantidad" slot-scope="row">
                    <div>
                    <b-form-input v-model="row.item.cantidad" placeholder="0"></b-form-input>
                    </div>
                </template>
                <template slot="accion" slot-scope="row">
                    <!-- <b-button size="sm" variant="primary" class="searchItem" @click="reciveitem(row.item)"><i class="fas fa-plus"></i></b-button> -->
                </template>
                </b-table>
            </div>         
             <div slot="modal-footer" class="w-100">
                 <b-row>
                    <b-col cols="1" class="mt-2">
                        <label>B&uacute;squeda:</label>        
                    </b-col>
                    <b-col cols="6" class="pl-4">
                        <b-form-input v-model="descripcion"  @keyup.enter="search()" placeholder="Descripción"></b-form-input>
                    </b-col>
                    <b-col cols="1">
                        <b-button variant="primary" class="searchItem" @click="search()" title="Buscar"><i class="fas fa-search"></i></b-button>
                    </b-col>
                    <b-col cols="2">
                         <b-button class="searchItem" variant="primary" @click="cargarItems()" title="Agregar">Agregar <i class="fas fa-plus"></i></b-button>
                    </b-col>
                     <b-col cols="2">
                         <!-- <b-button class="searchItem" variant="primary" @click="closeSearchItem()" title="Salir">Cerrar</b-button> -->
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <template>
            <div v-if="showPopup" class="popup">
                <div class="popup-content">
                <h2>Ups Error !</h2> 
                <p>No puede emitir Guias, por favor verifique que los datos de SUNAT esten activos</p>
                </div>
            </div>
        </template>
        <!-- <b-modal v-model="modalError500">
                <b-alert show variant="danger">
                    <div class="text-center">
                        <strong>    
                        <i class="fa fa-2x fa-exclamation-circle"></i>
                        Error 500 - Error en el servidor
                        </strong>
                        <p>Si el mensaje se vuelve a mostrar, por favor notificar al área de soporte.</p> 
                        <i class="fas fa-file-code" @click="copyJsonToClipboard" style="cursor: pointer;"></i> JSON
                    </div>
                </b-alert>
            <template v-slot:modal-footer>
                <b-button block variant="primary" @click="refreshPage">Actualizar y volver a intentar</b-button>
            </template>
        </b-modal>   -->
         <error-msj :errormodal="errorGuia" :error1="error1" :error2="error2" :error3="error3"@cerrarmodal="cerrarmodal" ></error-msj>
     </b-card>
     <vue-snotify></vue-snotify>
    </div>
    <div v-else>
        <b-card>
          <b-alert show variant="primary" class="centerpreview">
            <div class="text-center">
                <strong>    
                <i class="fa fa-2x fa-exclamation-circle"></i>
                Vista Previa - Datos aún sin valor oficial
                </strong>        
            </div>
          </b-alert>
            <b-row>
                <b-col cols="12" sm="7"	md="7"	lg="8"	xl="6">
                    <em><strong>Para:</strong></em><br>
                    <b-row>
                        <b-col cols="12" sm="6"	md="4"	lg="4"	xl="3">
                        RUC:
                        </b-col>
                        <b-col cols="12" sm="6"	md="4"	lg="8"	xl="9">
                        {{ receptor.numero }}
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" sm="6"	md="4"	lg="4"	xl="3">
                        Razon Social:
                        </b-col>
                        <b-col cols="12" sm="6"	md="4"	lg="8"	xl="9">
                            {{ receptor.razonSocial }}
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" sm="6"	md="4"	lg="4"	xl="3">
                        Direccion:
                        </b-col>
                        <b-col cols="12" sm="6"	md="4"	lg="8"	xl="9">
                        {{ receptor.direccion }}
                        </b-col>
                    </b-row>
                </b-col>
            <b-col cols="12" sm="5"	md="5"	lg="4"	xl="6">
              <em><strong>Detalles:</strong></em><br>
              <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="3">
                  Fecha Emision:
                </b-col>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="9">
                  {{ femision | moment('DD/MM/YYYY hh:mm:ss A') }}
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="3">
                  Dirección Partida:
                </b-col>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="9">
                  {{ direccionPartida}}
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="3">
                  Dirección Llegada:
                </b-col>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="9">
                  {{ direccionLlegada}}
                </b-col>
              </b-row>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
              <b-table responsive
                :small="small"
                :items="items"
                :fields="items_fields"
                :outlined="outlined"
                >
                <template slot="index" slot-scope="row">{{ row.index +1 }}</template>
              </b-table>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col cols="4" sm="6"	md="8"	lg="8"	xl="8"></b-col>
            <b-col cols="4" sm="3"	md="2"	lg="2"	xl="2">
                <template v-if="validateGuide()">
                    <button v-if="!cargandoemision" class="btn btn-primary botonesemitirNC" @click.prevent="sendGuide"><i class="fa fa-location-arrow"></i> Emitir</button>
                    <button v-else class="btn btn-seconday botonesemitirNC"><i class="fa fa-spin fa-spinner"></i> Emitiendo</button>
                </template>
                <template v-else>
                <button class="btn btn-secondary botonesemitirNC" disabled><i class="fa fa-send"></i> Emitir</button>
                </template>
            </b-col>
            <b-col cols="4" sm="3"	md="2"	lg="2"	xl="2">
                <template>
                <button class="btn btn-danger botonesemitirNC" @click="sendPreviw(false)"><i class="fa fa-arrow-circle-left"></i> Atr&aacute;s</button>
                </template>
            </b-col>
        </b-row>
        </b-card>
    </div>
</template>

<script>
const config = {
       headers: {
            'Content-type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin':'*',
            'Access-Control-Allow-Methods': 'POST',
            'Access-Control-Allow-Headers':'*',
            'cache-control': 'no-cache'
          }
}
import axios from 'axios'
import vSelect  from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
import { DocumentosIdentidad } from '@/shared/utils'
import { DocumentosIdentidadConductor } from '@/shared/utils'
import { DocumentosIdentidadGuia } from '@/shared/utils'
import { TipoGuia } from '@/shared/utils'
import { TipoMoneda } from '@/shared/utils'
import { MotivoTraslado } from '@/shared/utils'
import { UnidadMedida } from '@/shared/utils'
import { Departamentos } from '@/shared/utils'
import { DocumentosRelacionadosTransportePrivado } from '@/shared/utils'
import { DocumentosRelacionadosTransportePublico } from '@/shared/utils'
import GuiaRemision from '@/views/guiaremision/GuiaRemision'
import GuiaRemisionConsulta from '@/components/guiaremision/GuiaRemisionConsulta'
import vistaPostEmision from '@/components/comunes/VistaPostEmision'
import { entidadEmisora } from "@/shared/utils";
import Import from '@/components/comunes/pImportItems';
import { XlsxRead, XlsxJson, XlsxTable } from "vue-xlsx/dist/vue-xlsx.es.js";
import ErrorMsj from '@/components/comunes/Errormsj'
import {tipoVehiculoOpcion} from '@/shared/utils'

export default {
    name: 'GuiaRemisionEmision',
    components: {
        Datepicker,
        vSelect,
        GuiaRemision,
        GuiaRemisionConsulta,
        'vista-post-emison': vistaPostEmision,
        XlsxRead,
        XlsxJson,
        XlsxTable,
        Import,
        ErrorMsj
    },
    data: () => {
        return {
            postEmision: false,
            tipoDocPreview: 0,
            idDocumentPreview: 0,
            setIndex: -1,
            quickItems: [],
            items_fields: [
                {key: 'index', label: 'Item'},
                {key: 'cantidad', label: 'Cantidad', sorteable: true},
                {key: 'codigoItem', label: 'Código Producto', sorteable: true},
                {key: 'codigoProductoSunat', label: 'Código SUNAT', sorteable: true},
                {key: 'codigoProductoGs1', label: 'Código Barras', sorteable: true},
                {key: 'unidadMedida', label: 'Unidad Medida', sorteable: true},
                {key: 'descripcion', label: 'Descripción', sorteable: true},
                // {key: 'pesoProducto', label: 'Peso', sorteable: true},
                {key: 'acciones', label: 'Acciones', sorteable: true},
            ],
            striped: true,
            small: true,
            outlined: true,
            pactual: 1,
            limite: 10,
            orden: 'desc',
            total: 0.00,
            desde: 0.00,
            hasta: 0.00,
            filter: null,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            currentPage: 1,
            totalRows: null,
            previwEmit: true,
            fvencimientoItem: '',
            lote: '',
            peso: '',
            // pesoProducto:'',
            adicionalesItemsGuia: false,
            seriesCargadas: true,
            indexSerie: 0,
            rolSeries: '',
            listaSeries: [],
            documentoIdentidadGuia: DocumentosIdentidadGuia,
            disabledModalidadTraslado: null,
            cargandoDescription: false,
            cargandoCodigoInterno: false,
            cargandoCodigoBarras: false,
            listaDescription: [],
            listaCodigoInterno: [],
            listaCodigoBarras: [],
            listades: false,
            listCodigoInterno: false,
            listCodigoBarras: false,
            nodescription: false,
            noCodigoInterno: false,
            noCodigoBarras: false,
            setUpdateItem: false,
            codigoBarras: '',
            codigoSunat:'',
            numeroBultos: '',
            codigoPuerto: '',
            numeroDocumentoProveedor: '',
            tipoDocumentoProveedor: '6',
            numeroVehiculoSecundario: '',
            denominacionProveedor: '',
            direccionProveedor:'',
            index: '',
            numeroRelacionado: '',
            codigoRelacionado: '01',
            codigoRelacionadoImportacion: '04',
            listCodRelacionadoPrivado: DocumentosRelacionadosTransportePrivado,
            listCodRelacionadoPublico: DocumentosRelacionadosTransportePublico,
            numeroRucTransportista: '',
            listDepartamento: Departamentos,
            modalUbigeoDestino: false,
            modalUbigeoPartida: false,
            distDestino: false,
            distDestinoCargando: false,
            provDestino: false,
            provDestinoCargando: false,
            provOrigen: false,
            provOrigenCargando: false,
            distOrigen: false,
            distOrigenCargando:  false,
            prependUbigeoOrigen: '',
            prependUbigeoDestino: '',
            placeholderUbigeoPartida: 'Ubigeo Part.',
            placeholderUbigeoLlegada: 'Ubigeo LLeg.',
            departamentoSeleccionadoUbigeoOrigen: '',
            provinciaSeleccionadaUbigeoOrigen: '',
            distritoSeleccionadoUbigeoOrigen: '',
            departamentoSeleccionadoUbigeoDestino: '',
            provinciaSeleccionadaUbigeoDestino: '',
            distritoSeleccionadoUbigeoDestino: '',
            documentosRelacionados: [],
            documentosRelacionadosLocal: [],
            listDepartmentOrigen: [],
            listProvinceOrigen: [],
            listDistrictOrigen: [],
            listDepartmentDestino: [],
            listProvinceDestino: [],
            listDistrictDestino: [],
            nombresApellidosConductor: '',
            denominacionTransportista: '',
            numeroDocumentoConductor: '',
            numeroPlacaVehiculo: '',
            indicadorTrasladoVehiculoM1L:'',
            observaciones: '',
            descripcionMotivoTraslado: '',
            numeroContenedor: '',
            disabledTipo: null,
            disabledNumero: null,
            disabledFieldReceptor: null,
            disabledDireccionRemitente:null,
            disabledDatosConductor: null,
            nroDocumentoTransportista: '',
            documentoConductor: '1',
            documentoTransportista: '',
            tipoDocumentoTransportista: '6',
            cargandoemision: false,
            habilitado: false,
            listarecProveedor:false,
            listarec: false,
            norec: false,
            norecProveedor:false,
            listarecTransportista: false,
            listarecConductor: false,
            norecTransportista: false,
            norecConductor: false,
            unidadMedidaCantidad: 'NIU',
            unidades: UnidadMedida,
            motivodetraslado: MotivoTraslado,
            motivotraslado: '01',
            serie: '',
            tipodeguia: '09',
            tiposdeguia: TipoGuia,
            tipoMoneda: TipoMoneda,
            tipodemoneda: {
                id: '1',
                codigo: 'PEN',
                descripcion: 'SOLES',
                simbolo: 'S/.'
            },
            options: [
                { value: 1, text: 'Guia de Remision de Comercial' },
                { value: 2, text: 'Guia de Remision de Contingencia' }
            ],
            modalidadTraslado: [
                {
                    codigo: '01',
                    nombre: 'Transporte Publico'
                },
                {
                    codigo: '02',
                    nombre: 'Transporte Privado'
                }
            ],
            modalidaddetraslado: '01',
            cantidad: 1,
            descripcion: '',
            codigoItem: '',
            venta: '',
            compra: '',
            consignacion: '',
            ventaTerceros: '',
            ventaConfirmacion: '',
            trasladoInterno: '',
            devolucion: '',
            ubigeoPartida: '',
            direccionPartida: '',
            ubigeoLlegada: '',
            direccionLlegada: '',
            status: '',
            fechaEmision: '',
            fechaInicioTraslado: '',
            femision: '',
            finicioTraslado: '',
            fechaEntregaBienesTransportista:'',
            es: es,
            diasnopermitidos: {
            ranges: []
            },
            diasnopermitidosBienesTrans: {
            ranges: []
            },
            diasFechaTrasporte: {
            ranges: []
            },
            currentdate: '',
            currentdateTransporte:'',
            documentosIdentidad: DocumentosIdentidad,
            documentosIdentidadConductor: DocumentosIdentidad,
            documentosIdentidadTransportista: [
                {
                    nombre: 'RUC',
                    tipo: '6'
                }
            ],
            tipoDocumento: 6,
            receptor: {
                tipo:'',
                numero:'',
                razonSocial:'',
                direccion:''                               
            },
            logitudDoc: 12,
            cargandoreceptor: false,
            cargandoProveedor:false,
            cargandoreceptorTransportista: false,
            cargandoreceptorConductor: false,
            listaReceptoresProveedores:[],
            listaReceptores: [],
            listaTransportista: [],
            listaConductor:false,
            referralGuide: {
                token: '',
                serie: '',
                tipoDocumentoGuia: '',
                motivoTraslado: '',
                pesoBrutoTotal: '',
                unidadPesoBruto: '',
                modalidadTraslado: '',
                fechaInicioTraslado: '',
                ubigeoLlegada: '',
                direccionLlegada: '',
                ubigeoPartida: '',
                direccionPartida: '',
                adicional: {
                    vehiculoPrincipal:{
                        numeroPlacaVehiculo:''
                    }, 

                    datosTraslado:{
                        indicadorTrasladoVehiculoM1L: '',
                    }
                },
                // documentosRelacionados: [],
                receptor: {
                    tipo:'',
                    numero:'',
                    razonSocial:'',
                    direccion:''
                },
                items: [
                    {
                        cantidad: '',
                        descripcion: '',
                        codigoItem: '',
                        unidadMedida: ''
                    }
                ]
            },
            items: [],
            info: null,
            inicioTraslado: '',
            pesoBruto: '',
            datosRemitenteFactura: {},
            datosRemitenteBoleta: {},
            bufferProforma: {},
            bufferInvoice: {},
            bufferBoleta: {},
            arrayboleta:[],
            file:null,
            coleccion:[],
            itemsEX:[],
            action: {
                g: false,
                reset: false
            },
            cargandoUbigeo:false,
            listadesUbigeo:false,
            nodescriptionUbigeo:false,
            listaDescriptionUbigeo:[],
            sinresultados: false,
            verDirecciones: false,
            verDireccionesLlegada:false,
            direcciones: [],
            //prueba de ubigeo
            listUbigeo:[],
            mostrarubigeoTexto:false,
            indexUbigeo:0,

            filtrando:[],
            searchItems:false,
            mostrarListaProduc:false,
            ListProductos:[],
            List_Productos:[
                { key: "cantidad", label:"Cantidad", sortable:true},
                { key: "codigo", label:"codigo", sortable:true},
                { key: "descripcion", label:"Producto", sortable:true},
                { key: "stock", label:"Stock", sortable:true},
                { key: "precioUnitario", label:"P.Venta", sortable:true},
                { key: "accion", label:""}
            ],
            itemsModal:[],
            errorGuia:false,
            error1:'',
            error2:'',
            error3:'',
            informacionAdicional:'',
            selectedDirUbigeo:null,
            optionsUbigeo:[],
            filtroUbigeoDir:[],
            mostrarUbigeo:false,

            tipoDocConductor:1,
            bloquearCampoConductor:false,
            numDoc:'',
            nombreConductor:'',
            apellidoConductor:'',
            numLicencia:'',
            conductoresAsociados:[],
            listaConductorAsociado:false,
            listaConductores:[],
            botonEditarConductor:false,
            recibeConductorSecundario:[],
            recibeConductor_Secundario:[
                { key: "tipoConductor", label:"Tipo Conductor"},
                { key: "tipoDocumentoConductor", label:"Tipo Documento"},
                { key: "numeroDocumentoConductor", label:"Documento"},
                { key: "nombresConductor", label:"Nombre"},
                { key: "apellidosConductor", label:"Apellido"},
                { key: "numeroLicenciaConductor", label:"Licencia"},
                { key: "acciones", label:"Editar / Eliminar"}
            ],
            indexConductor:-1,
            placaVehiculo:'',
            numCirculacionVehiculo:'',
            codEntidadEmisora:0,
            codEntidadEmisoraSecundario:0,
            numAutorizacionVehiculo:'',
            listaVehiculo:false,
            listaVehiculos:[],
            infoEntidadEmisora:entidadEmisora,
            bloquearCampoVehiSecundario: true,
            placaVehiculoSecundario:'',
            listaVehiculoSecundario:false,
            listaVehiculosSecundarios:[],
            numAutorizacionVehiculoSecundario:'',
            botonEditar:false,
            recibeVehiculoSecundario:[],
            recibeVehiculos_Secundario:[
                { key: "numeroPlacaVehiculo", label:"Placa"},
                // { key: "numeroCirculacionVehiculo", label:"Circulación"},
                // { key: "nomEntidadEmisora", label:"Nombre Entidad"},
                // { key: "codEntidadEmisora", label:"Codigo Entidad"},
                // { key: "numeroAutorizacionVehiculo", label:"Nro. Autorización"},
                { key: "acciones", label:"Editar / Eliminar"}
            ],
            numCirculacionVehiculoSecundario:'',
            indexVehiculoSecundario:-1,
            conVehiculo:false,
            serieContingencia:'',
            numeroContingencia:'',
            tipoVehiculoOpcion:tipoVehiculoOpcion,
            tipoVehiculo:'01',
            faltaSeleccionarVehiculo:false,
            bloquearCampoVehiPrincipal:true,
            // modalError500:false,
            errorJson: null,
            contadorDescripcion:0,
            datosSunatGuias:[],
            showPopup: false,
            c:{},
            listadni:[],
            mostrardni:false,
        }
    },
    mounted () {
        this.initDates(),
        this.diasFechaTrasporteGr(),
        this.searchDepartmentOrigen(),
        this.searchDepartmentDestino(),
        this.getSeries(),
        this.bringItems(),
        this.listarUbigeos(),
        this.validarDatosSunat(),
        this.copiarGuiasRemitente()
    },
    computed: {
        stateCirculacionVehiculoPlaca () {
            let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.placaVehiculo.length == 0){

            } else if (this.placaVehiculo.length < 6)  {
                return false
            } else if(this.placaVehiculo.length == 7 ){
                return true
            }
        },
        invalidFeedbackCirculacionVehiculoPlaca() {
            // let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.placaVehiculo.length == 1) {
                return 'Ingresar mínimo 6 valores y máximo 7'
            } else {
                return 'Ingresar mínimo 6 valores y máximo 7'
            }
        },
        stateCirculacionVehiculoPlacaSecun () {
            let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.placaVehiculoSecundario.length == 0){

            } else if (this.placaVehiculoSecundario.length < 6)  {
                return false
            } else if(this.placaVehiculoSecundario.length == 7 ){
                return true
            }
        },
        invalidFeedbackCirculacionVehiculoPlacaSecun() {
            // let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.placaVehiculoSecundario.length < 6) {
                return 'mínimo 6 valores y máximo 7'
            }else if(this.placaVehiculoSecundario == this.placaVehiculo){
                return 'Placa debe ser diferente a la principal'
            }
        },
        stateCirculacionVehiculo () {
            let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.numCirculacionVehiculo.length == 0){

            } else if (this.numCirculacionVehiculo.length < 10)  {
                return false
            } else if(this.numCirculacionVehiculo.length == 40 ){
                return true
            }
        },
        invalidFeedbackCirculacionVehiculo() {
            // let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.numCirculacionVehiculo.length == 1) {
                return 'Ingresar mínimo 10 valores'
            } else {
                return 'Ingresar mínimo 10 valores '
            }
        },
        stateCirculacionVehiculoSecun () {
            let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.numCirculacionVehiculoSecundario.length == 0){

            } else if (this.numCirculacionVehiculoSecundario.length < 10)  {
                return false
            } else if(this.numCirculacionVehiculoSecundario.length == 40 ){
                return true
            }
        },
        invalidFeedbackCirculacionVehiculoSecun() {
            // let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.numCirculacionVehiculoSecundario.length == 1) {
                return 'Ingresar mínimo 10 valores'
            } else {
                return 'Ingresar mínimo 10 valores '
            }
        },
        state () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serie.length == 0){
                
            } else if (!expreg.test(this.serie)) {
                return false
            } else if(this.serie.length == 3 ){
                return true
            }
        },
        invalidFeedback () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serie.length == 0) {
                return 'Ingresa un Número'
            } else {
                return 'Minimo 3 caracteres'
            }
        },
        validFeedback () {
        return this.state === true ? 'Perfecto' : ''
        },
        stateDam () {
            let expreg = new RegExp("^[0-9]{4}-[0-9]{2}-[0-9]{3}-[0-9]{6}$")
            if (this.numeroRelacionado.length == 0){

            } else if (!expreg.test(this.numeroRelacionado)) {
                return false
            } else if(this.numeroRelacionado.length == 18 ){
                return true
            }
        },
        invalidFeedbackDam () {
            let expreg = new RegExp("^[0-9]{4}-[0-9]{2}-[0-9]{3}-[0-9]{6}$")
            if (this.numeroRelacionado.length == 18) {
                return 'Ingresa Número Dam'
            } else {
                return 'La cadena debe tener la forma: 0000-00-000-000000'
            }
        },
        validFeedbackDam () {
        return this.stateDam === true ? 'Perfecto' : ''
        },
        stateManifiesto () {
            let expreg = new RegExp("^[0-9]{3}-[0-9]{4}-[0-9]{4}$")
            if (this.numeroRelacionado.length == 0){

            } else if (!expreg.test(this.numeroRelacionado)) {
                return false
            } else if(this.numeroRelacionado.length == 13 ){
                return true
            }
        },
        invalidFeedbackManifiesto () {
            let expreg = new RegExp("^[0-9]{3}-[0-9]{4}-[0-9]{4}$")
            if (this.numeroRelacionado.length == 13) {
                return 'EL número ingresado contiene errores'
            } else {
                return 'La cadena debe tener la forma: 000-0000-0000'
            }
        },
        validFeedbackManifiesto () {
        return this.stateManifiesto === true ? 'Perfecto' : ''
        },
        stateRelacionadosPrivado () {
            let expreg = new RegExp("^[0-9]{20}$")
            if (this.numeroRelacionado.length == 0){

            } else if (!expreg.test(this.numeroRelacionado)) {
                return false
            } else if(this.numeroRelacionado.length == 20 ){
                return true
            }
        },
        invalidFeedbackRelacionadosPrivado () {
            let expreg = new RegExp("^[0-9]{20}$")
            if (this.numeroRelacionado.length == 20) {
                return 'EL número ingresado contiene errores'
            } else {
                return 'La cadena debe contener minimo 20 caracteres'
            }
        },
        validFeedbackRelacionadosPrivado () {
        return this.stateRelacionadosPrivado === true ? 'Perfecto' : ''
        },
        stateUbigeoPartida () {
            let expreg = new RegExp("^[0-9]{6}$")
            if (this.ubigeoPartida.length == 0){

            } else if (!expreg.test(this.ubigeoPartida)) {
                return false
            } else if(this.ubigeoPartida.length == 6 ){
                return true
            }
        },
        invalidFeedbackUbigeoPartida () {
            let expreg = new RegExp("^[0-9]{6}$")
            if (this.ubigeoPartida.length == 0) {
                return 'Ingresa un Ubigeo'
            } else {
                return 'Minimo 6 Números'
            }
        },
        validFeedbackUbigeoPartida () {
        return this.stateUbigeoPartida === true ? 'Perfecto' : ''
        },
        stateUbigeoLlegada () {
            let expreg = new RegExp("^[0-9]{6}$")
            if (this.ubigeoLlegada.length == 0){

            } else if (!expreg.test(this.ubigeoLlegada)) {
                return false
            } else if(this.ubigeoLlegada.length == 6 ){
                return true
            }
        },
        invalidFeedbackUbigeoLlegada () {
            let expreg = new RegExp("^[0-9]{6}$")
            if (this.ubigeoLlegada.length == 0) {
                return 'Ingresa un Ubigeo'
            } else {
                return 'Minimo 6 Números'
            }
        },
        validFeedbackUbigeoLlegada () {
        return this.stateUbigeoLlegada === true ? 'Perfecto' : ''
        },
        stateDireccionPartida () {
            let expreg = new RegExp("^(?:[^<>{}]|{[^<>{}]*}){1,250}$")
            if (this.direccionPartida.length == 0){

            } else if (!expreg.test(this.direccionPartida)) {
                return false
            } else if(this.direccionPartida.length > 1 ){
                return true
            }
        },
        invalidFeedbackDireccionPartida () {
            let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.direccionPartida.length == 1) {
                return 'Ingresa una dirección valida'
            } else {
                return 'La cadena contiene un error'
            }
        },
        validFeedbackDireccionPartida () {
        return this.stateDireccionPartida === true ? 'Perfecto' : ''
        },
        stateDireccionLlegada () {
            let expreg = new RegExp("^(?:[^<>{}]|{[^<>{}]*}){1,100}$")
            if (this.direccionLlegada.length == 0){

            } else if (!expreg.test(this.direccionLlegada)) {
                return false
            } else if(this.direccionLlegada.length > 1 && this.direccionLlegada.length < 101 ){
                return true
            }
        },
        invalidFeedbackDireccionLlegada () {
            let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.direccionLlegada.length == 1) {
                return 'Ingresa una dirección valida'
            } else {
                return 'El rango máximo de caracteres permitido es 100' + ' | ' + ' Caracteres actuales: ' + this.direccionLlegada.length
            }
        },
        validFeedbackDireccionLlegada () {
        return this.stateDireccionLlegada === true ? 'Perfecto' : ''
        },
        stateNumeroRucTransportista () {
            let expreg = new RegExp("^[0-9]{11}$")
            if (this.numeroRucTransportista.length == 0){

            } else if (!expreg.test(this.numeroRucTransportista)) {
                return false
            }else if(this.numeroRucTransportista == this.receptor.numero){
                return false
            } else if(this.numeroRucTransportista.length == 11  ){
                return true
            }
        },
        invalidFeedbackNumeroRucTransportista () {
            let expreg = new RegExp("^[0-9]{11}$")
            if (this.numeroRucTransportista.length == 0) {
                return 'RUC es obligatorio'
            } else if(this.numeroRucTransportista.length != 11) {
                return 'Minimo 11 digitos'
            } else if(this.numeroRucTransportista == this.receptor.numero){
                return 'RUC no debe ser igual al receptor'
            }
        },
        validFeedbackNumeroRucTransportista () {
        return this.stateNumeroRucTransportista === true ? 'Perfecto' : 'RUC no debe ser igual al receptor'
        },
        stateDenominacionTransportista () {
            let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.denominacionTransportista.length == 0){

            } else if (!expreg.test(this.denominacionTransportista)) {
                return false
            } else if(this.denominacionTransportista.length > 1 ){
                return true
            }
        },
        invalidFeedbackDenominacionTransportista () {
            let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.denominacionTransportista.length == 1) {
                return 'Ingresa una dirección valida'
            } else {
                return 'La cadena contiene un error'
            }
        },
        validFeedbackDenominacionTransportista () {
        return this.stateDenominacionTransportista === true ? 'Perfecto' : ''
        },
        stateNumeroBultos () {
            let expreg = new RegExp("^[0-9]{1,10}$")
            if (this.numeroBultos.length == 0){

            } else if (!expreg.test(this.numeroBultos)) {
                return false
            } else if(this.numeroBultos.length > 0 ){
                return true
            }
        },
        invalidFeedbackNumeroBultos () {
            let expreg = new RegExp("^[0-9]{1,10}$")
            if (this.numeroBultos.length == 0) {
                return 'Ingresa cantidad de bultos'
            } else {
                return 'Minimo 1 Número'
            }
        },
        validFeedbackNumeroBultos () {
        return this.stateNumeroBultos === true ? 'Perfecto' : ''
        },
        stateCodigoPuerto () {
            let expreg = new RegExp("^[0-9]{1,10}$")
            if (this.codigoPuerto.length == 0){

            } else if (!expreg.test(this.codigoPuerto)) {
                return false
            } else if(this.codigoPuerto.length > 0 ){
                return true
            }
        },
        invalidFeedbackCodigoPuerto () {
            let expreg = new RegExp("^[0-9]{1,10}$")
            if (this.codigoPuerto.length == 0) {
                return 'Ingresa el codigo de puerto'
            } else {
                return 'Codigo Invalido'
            }
        },
        validFeedbackCodigoPuerto () {
        return this.stateCodigoPuerto === true ? 'Perfecto' : ''
        },
        stateNumeroVehiculoSecundario () {
            let expreg = new RegExp("^[0-9]{1,15}$")
            if (this.numeroVehiculoSecundario.length == 0){

            } else if (!expreg.test(this.numeroVehiculoSecundario)) {
                return false
            } else if(this.numeroVehiculoSecundario.length > 0 ){
                return true
            }
        },
        invalidFeedbackNumeroVehiculoSecundario () {
            let expreg = new RegExp("^[0-9]{1,15}$")
            if (this.numeroVehiculoSecundario.length == 0) {
                return 'Ingresa el numero de vehiculo'
            } else {
                return 'Numero de vehiculo Invalido'
            }
        },
        validFeedbackNumeroVehiculoSecundario () {
        return this.stateNumeroVehiculoSecundario === true ? 'Perfecto' : ''
        },
        stateNumeroDocumentoProveedor () {
            let expreg = new RegExp("^[0-9]{1,15}$")
            if (this.numeroDocumentoProveedor.length == 0){

            } else if (!expreg.test(this.numeroDocumentoProveedor)) {
                return false
            } else if(this.numeroDocumentoProveedor.length > 0 ){
                return true
            }
        },
        invalidFeedbackNumeroDocumentoProveedor () {
            let expreg = new RegExp("^[0-9]{1,15}$")
            if (this.numeroDocumentoProveedor.length == 0) {
                return 'Ingresa un numero de doc'
            } else {
                return 'Numero de documento Invalido'
            }
        },
        validFeedbackNumeroDocumentoProveedor () {
        return this.stateNumeroDocumentoProveedor === true ? 'Perfecto' : ''
        },
        stateDenominacionProveedor () {
            let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.denominacionProveedor.length == 0){

            } else if (!expreg.test(this.denominacionProveedor)) {
                return false
            } else if(this.denominacionProveedor.length > 1 ){
                return true
            }
        },
        invalidFeedbackDenominacionProveedor () {
            let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.denominacionProveedor.length == 1) {
                return 'Ingresa una dirección valida'
            } else {
                return 'La cadena contiene un error'
            }
        },
        validFeedbackDenominacionProveedor () {
        return this.stateDenominacionProveedor === true ? 'Perfecto' : ''
        },
        // statePesoBruto () {
        //     let expreg = new RegExp("^[0-9]{1,10}$")
        //     if (this.pesoBruto.length == 0){

        //     } else if (!expreg.test(this.pesoBruto)) {
        //         return false
        //     } else if(this.pesoBruto.length > 0 ){
        //         return true
        //     }
        // },
        // invalidFeedbackPesoBruto () {
        //     let expreg = new RegExp("^[0-9]*\.?[0-9]{0,2}$")
        //     if (this.pesoBruto.length == 0) {
        //         return 'Ingresa peso bruto '
        //     } else {
        //         return 'Peso bruto Invalido'
        //     }
        // },
        // validFeedbackPesoBruto () {
        // return this.statePesoBruto === true ? 'Perfecto' : ''
        // },
        // stateCantidad () {
        //     let expreg = new RegExp("^[0-9]{1,10}$")
        //     if (this.cantidad.length == 0){

        //     } else if (!expreg.test(this.cantidad)) {
        //         return false
        //     } else if(this.cantidad.length > 0 ){
        //         return true
        //     }
        // },
        // invalidFeedbackCantidad () {
        //     let expreg = new RegExp("^[0-9]{1,10}$")
        //     if (this.cantidad.length == 0) {
        //         return 'Ingresa cantidad'
        //     } else {
        //         return 'Cantidad Invalido'
        //     }
        // },
        // validFeedbackCantidad () {
        // return this.stateCantidad === true ? 'Perfecto' : ''
        // }
    },
    watch: {
        placaVehiculoSecundario(valor){
            if (valor) {
                this.placaVehiculoSecundario = valor.toUpperCase()
            }
        },
        placaVehiculo(valor){
            if (valor) {
                this.placaVehiculo = valor.toUpperCase();
            }
            if(this.placaVehiculo.length > 5){
                this.bloquearCampoVehiSecundario = false;
            }else if(this.placaVehiculo.length < 6){
                this.bloquearCampoVehiSecundario = true;
                this.placaVehiculoSecundario = ''
            }
        },
        pesoBruto(){
             if(this.pesoBruto.charAt(0) == "0"){
                   setTimeout(() => this.pesoBruto = '', 100);   
            }
        },
        numDoc(){
             if(this.numDoc.length == 8){
                this.tipoDocConductor = 1
            }else if(this.numDoc.length == 11){
                this.tipoDocConductor = 6
            }
            if(this.numDoc.length < 2){
                this.nombreConductor = '';
                this.apellidoConductor = '';
                this.numLicencia = '';
            }
            if(this.tipoDocConductor == 6){
                if(this.numDoc.charAt(0) == "2"){
                   setTimeout(() => this.numDoc = '', 200);   
                }
            }
        },
        numeroDocumentoConductor(){
            if(this.documentoConductor == 6){
                if(this.numeroDocumentoConductor.charAt(0) == "2"){
                   setTimeout(() => this.numeroDocumentoConductor = '', 200);   
                }
            }
        },
        tipoDocumento(){
            if(this.tipoDocumento !=6 && this.tipoDocumento !=1 && this.motivotraslado != '18'){
                this.habilitado = true
            }else{
                this.habilitado = false
            }
        },
        listaReceptores: function() {
            if (this.listaReceptores.length == 1 && this.receptor.numero.length == 11){
                this.setReceiver(this.listaReceptores[0]);
            }
        },
        listaReceptoresProveedores: function() {
            if (this.listaReceptoresProveedores.length == 1 && this.numeroDocumentoProveedor.length == 11){
                this.setReceiverProveedor(this.listaReceptoresProveedores[0]);
            }
        },
        listaTransportista: function() {
            if (this.listaTransportista.length == 1 && this.numeroRucTransportista.length == 11){
                this.setReceiverTransportista(this.listaTransportista[0]);
            }
        },
        "receptor.numero": function() {
            if (this.receptor.numero.length < 3) {
                this.initReceptor();
            }else if(this.receptor.numero.length == 8 ){
                this.tipoDocumento = 1;
            }else if(this.receptor.numero.length == 11 ){
                this.tipoDocumento = 6;
            }
        },
        numeroDocumentoProveedor: function() {
            if (this.numeroDocumentoProveedor.length < 3) {
                this.initReceptorProveedor();
            }
        },
        numeroRucTransportista(){
            if(this.receptor.numero == this.numeroRucTransportista){
                this.numeroRucTransportista = ''
                this.denominacionTransportista =''
                // this.$snotify.warning('El RUC del transportista no debe ser igual al receptor')
            }
        },
        direccionPartida: function () {
             if(this.direccionPartida.length == 0){
                this.listadesUbigeo = false,
                this.listaDescriptionUbigeo = [],
                this.ubigeoPartida = '',
                this.sinresultados = false
            }
        },
        coleccion:function(){
            if(this.coleccion !=null){                   
                this.itemsEX = this.coleccion
                this.action.g = true                  
            }else{
                
            }
        },
        tipoVehiculo:function(){ //auto o moto true 01
            if(this.tipoVehiculo == '01'){
                this.conVehiculo = true,
                this.bloquearCampoVehiPrincipal = true;
            }else if(this.tipoVehiculo == '02'){  //otros false 02
                this.conVehiculo = false,
                this.bloquearCampoVehiPrincipal = false
                // this.recibeConductorSecundario = [],
                // this.bloquearCampoConductor = false;
            }
        },
        modalidaddetraslado: function () { //si es publico 01, si es privado es 02
            if(this.modalidaddetraslado == '01'){
                this.conVehiculo = false;
                this.tipoVehiculo = '01';
                this.documentoConductor = '0'
                this.documentosIdentidadConductor = DocumentosIdentidad
            }else{
                this.documentoConductor = '1'
                this.documentosIdentidadConductor = DocumentosIdentidadConductor
                this.conVehiculo = true;
            }
            if(this.motivotraslado == '08'){
                this.disabledDatosConductor = ''
            }else{
                this.disabledDatosConductor = null
            }
        },
        distritoSeleccionadoUbigeoOrigen: function () {
            this.distOrigenCargando = false,
            this.ubigeoPartida = this.departamentoSeleccionadoUbigeoOrigen + this.provinciaSeleccionadaUbigeoOrigen + this.distritoSeleccionadoUbigeoOrigen.codDistrito,
            this.prependUbigeoOrigen = this.distritoSeleccionadoUbigeoOrigen.nombre,
            this.modalUbigeoPartida = false

        },
        provinciaSeleccionadaUbigeoOrigen: function () {
            this.distOrigen = true,
            this.distOrigenCargando = true,
            this.searchDistrictOrigen(this.distOrigenCargando)
        },
        departamentoSeleccionadoUbigeoOrigen: function () {
            this.provOrigen = true,
            this.searchProvinceOrigen()
        },
        distritoSeleccionadoUbigeoDestino: function () {
            this.distDestinoCargando = false,
            this.ubigeoLlegada = this.departamentoSeleccionadoUbigeoDestino + this.provinciaSeleccionadaUbigeoDestino + this.distritoSeleccionadoUbigeoDestino.codDistrito,
            this.prependUbigeoDestino = this.distritoSeleccionadoUbigeoDestino.nombre,
            this.modalUbigeoDestino = false
            
        },
        provinciaSeleccionadaUbigeoDestino: function () {
            this.distDestino = true,
            this.distDestinoCargando = true,
            this.searchDistrictDestino(this.distDestinoCargando)
        },
        departamentoSeleccionadoUbigeoDestino: function () {
            this.provDestino = true,
            this.searchProvinceDestino()
        },
        receptor: function () {
            this.getReceivers(this.receptor.toString())
        },
        motivotraslado: function () {
            if(this.motivotraslado == '04'){
                this.tipoDocumento = '6',
                this.disabledFieldReceptor = ''
                this.receptor.numero = this.$store.getters.userData.cuenta.idEmisor,
                this.receptor.razonSocial = this.$store.getters.userData.cuenta.razonSocial,
                this.receptor.direccion = this.$store.getters.userData.cuenta.direccion.direccion
            }else if(this.motivotraslado == '08'){
                this.modalidaddetraslado = '01',
                this.disabledModalidadTraslado = true,
                this.tipoDocumentoTransportista = '6'
            }else if(this.motivotraslado == '02'){
                this.modalidaddetraslado = '01',
                this.disabledModalidadTraslado = false,
                this.tipoDocumentoTransportista = '6',
                this.disabledTipo = true,
                this.tipoDocumento = 6,
                this.disabledFieldReceptor = true,
                this.disabledDireccionRemitente = true,
                this.receptor.numero = this.$store.getters.userData.cuenta.idEmisor,
                this.receptor.razonSocial = this.$store.getters.userData.cuenta.razonSocial
                this.receptor.direccion = this.$store.getters.userData.cuenta.direccion.direccion
            }else if(this.motivotraslado == '18'){
                this.tipoDocumento = 6,
                this.receptor.numero = this.$store.getters.userData.cuenta.idEmisor,
                this.receptor.direccion = this.$store.getters.userData.cuenta.direccion.direccion
                this.disabledTipo = true,
                this.disabledFieldReceptor = true,
                this.disabledDireccionRemitente = true
                this.disabledModalidadTraslado = false
            }else{
                this.tipoDocumento = '6',
                this.disabledTipo = null,
                this.disabledNumero = null,
                this.disabledFieldReceptor = null,
                this.disabledModalidadTraslado = null,
                this.disabledDireccionRemitente = null,
                this.receptor.numero = '',
                this.receptor.razonSocial = '',
                this.receptor.direccion = ''
            }   
        },
        selectedDirUbigeo(){
            if(this.listUbigeo[this.selectedDirUbigeo].ubigeo){
                this.ubigeoPartida = this.listUbigeo[this.selectedDirUbigeo].ubigeo
                this.direccionPartida = this.listUbigeo[this.selectedDirUbigeo].direccion
            }else{
                 this.ubigeoPartida = ''
            }
        }
    },
    methods: {
        onChange(event) {
            this.file = event.target.files ? event.target.files[0] : null;
        },
        totalitems(value){
            this.items = value
            this.action.g = false
        },
        backEmision(value) {
            if(value === 0){
                this.postEmision = false
                this.listarUbigeos();
            }else if(value != 0){
                this.listarUbigeos();
                this.idDocumentPreview = value
                this.tipoDocPreview = 5
                this.postEmision = true
            }
        },
        bringItems: function () {
            let itemBlank = []
            this.bufferProforma = this.$store.getters.getproforma
            this.datosRemitenteFactura = this.$store.getters.obtieneRemitente //OBTIENE DATOS REMITENTE FACTURA
            this.datosRemitenteBoleta = this.$store.getters.obtieneRemitenteBoletaGuia //OBTIENE DATOS REMITENTE BOLETA
            this.bufferInvoice = this.$store.getters.bringItems //OBTIENE ITEMS DE FACTURA
            this.bufferBoleta = this.$store.getters.getboletaGuias
            if(Array.isArray(this.bufferInvoice.details)){
                this.receptor.numero = this.bufferInvoice.idReceptor
                this.quickItems =  this.bufferInvoice.details
                this.observaciones = (this.bufferInvoice.serie + "-" + this.bufferInvoice.numero)
                this.tipoDocumento = this.datosRemitenteFactura.receiver.tipo
                this.receptor.numero = this.datosRemitenteFactura.receiver.idReceptor
                this.receptor.razonSocial = this.datosRemitenteFactura.receiver.razonSocial
                this.receptor.direccion = this.datosRemitenteFactura.receiver.direccionReferencia
                this.$store.commit('itemstransient', itemBlank)
            }else if(Object.values(this.bufferProforma).length > 0){
                if(this.bufferProforma.proforma.receptor.tipo != 0){
                    this.tipoDocumento = this.bufferProforma.proforma.receptor.tipo
                    this.receptor.numero = this.bufferProforma.proforma.receptor.nro
                    this.receptor.razonSocial = this.bufferProforma.proforma.receptor.razonSocial
                    this.receptor.direccion = this.bufferProforma.proforma.receptor.direccionFiscal
                }
                this.quickItems = this.bufferProforma.proforma.items
                this.$store.commit('setproforma', itemBlank)
            }else if(this.bufferBoleta){
                this.quickItems = this.bufferBoleta
                if(this.datosRemitenteBoleta && this.datosRemitenteBoleta.receiver && this.datosRemitenteBoleta.receiver.idReceptor != '-'){
                    this.tipoDocumento = this.datosRemitenteBoleta.receiver.tipo
                    this.receptor.numero = this.datosRemitenteBoleta.receiver.idReceptor
                    this.receptor.razonSocial = this.datosRemitenteBoleta.receiver.razonSocial
                    this.receptor.direccion = this.datosRemitenteBoleta.receiver.direccionReferencia
                }else{
                    this.listarUbigeos()
                }
                this.$store.commit('setboletaGuias', itemBlank)
                this.$store.commit('setboletaGuias', null)
            }
            this.addQuickItem()
        },
        updateItem: function (index, itemUpdate) {
            let itemChange = itemUpdate
            let item = {}
            this.setUpdateItem = true
            this.setIndex = index
            this.cantidad = itemChange.cantidad
            this.unidadMedidaCantidad = itemChange.unidadMedida
            this.codigoItem = itemChange.codigoItem
            this.codigoBarras = itemChange.codigoProductoGs1
            this.codigoSunat = itemChange.codigoProductoSunat
            this.descripcion = itemChange.descripcion
            this.precioVentaUnitario = itemChange.precioVentaUnitario
            this.valorUnitario = itemChange.valorUnitario
        },
        executeUpdate: function () {
            this.nodescription = false
            this.addItem()
        },
        sendPreviw: function (value) {
            this.initDates()
            this.diasFechaTrasporteGr()
            if(this.numeroRucTransportista == this.receptor.numero){
                this.$snotify.warning( 'RUC Transportisa y RUC Receptor no deben ser iguales')
            }else{
                 if(value){
                this.previwEmit = false
                }else{
                this.previwEmit = true
                }
            }  
        },
        getSeries: function () {
            this.seriesCargadas = true,
            axios
            .post(process.env.VUE_APP_API_URL + 'usuario/series/7', {
                token: this.$store.getters.userToken
            })
            .then(response => (
                this.listaSeries = response.data.data, 
                this.rolSeries = response.data.rol,
                this.seriesCargadas = false
                ))
            .catch(error => {})
        },
        getReceiversCodigoInterno: function () {
                if(this.codigoItem.length >= 2 ){
                    setTimeout(() => 
                    this.cargandoCodigoInterno = true,
                    this.listCodigoInterno = true,
                    this.noCodigoInterno = false,
                    axios
                        .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                            token: this.$store.getters.userToken,
                            // 'name, code, codesunat, codegs1'
                            // Parametro ej: Shoes -> sho    
                            filtro: 'code',
                            p: this.codigoItem
                        })
                        .then(response => (
                            this.listaCodigoInterno = response.data.response,
                            this.cargandoCodigoInterno = false,
                            // this.listCodigoInterno = false,
                            this.receivercountCodigoInterno(this.listaCodigoInterno.length)                                 
                        ))
                        .catch(error => {
                            this.cargandoCodigoInterno = false,
                            this.listCodigoInterno = false,
                            this.noCodigoInterno = false
                        })
                ,200);  
                }
        },
        receivercountCodigoInterno: function (value) {
            if(value > 0)
            {
                this.noCodigoInterno = true
            }
            else
            {
                this.noCodigoInterno = false
            }
        },
        setReceiverCodigoInterno: function (item) {
            this.codigoItem = item.codigo,
            this.codigoSunat = item.codigoProductoSunat,
            this.codigoBarras = item.codigoProductoGs1,
            this.descripcion = item.descripcion,
            // this.cantidad = 1,
            this.unidadMedidaCantidad = item.unidadMedida,
            this.listCodigoInterno = false,
            this.listaCodigoInterno = []
        },
        getReceiversCodigoBarras: function () {
            this.cargandoCodigoBarras = true
            this.listCodigoBarras = true
        //    this.noCodigoBarras = false
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                token: this.$store.getters.userToken,
                    // 'name, code, codesunat, codegs1'
                    // Parametro ej: Shoes -> sho    
                filtro: 'codegs1',
                p: this.codigoBarras
            })
            .then(response => (
                this.setReceiverCodigoBarras(response.data.response),
                this.cargandoCodigoBarras = false,
                this.noCodigoBarras = false                               
            ))
            .catch(error => (
                this.noCodigoBarras = false,
                this.cargandoCodigoBarras = false
            ))
        },
        receivercountCodigoInterno: function (value) {
            if(value > 0)
            {
                this.noCodigoBarras = true
            }
            else
            {
                this.noCodigoBarras = false
            }
        },
        setReceiverCodigoBarras: function (item) {
            this.codigoItem = item[0].codigo,
            this.descripcion = item[0].descripcion,
            this.unidadMedidaCantidad = item[0].unidadMedida
            // this.listCodigoBarras = false,
            // this.listaCodigoBarras = []
        },
        getReceiversDescription: function () {
            this.contadorDescripcion = this.descripcion.length;
            if(this.descripcion.length === 3 || this.descripcion.length === 6 || this.descripcion.length >= 9){
                setTimeout(() => 
                    //  if(this.setIndex == -1){
                    this.cargandoDescription = true,
                    this.listades = true,
                    this.nodescription = false,
                    axios
                    .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                        token: this.$store.getters.userToken,
                        // 'name, code, codesunat, codegs1'
                        // Parametro ej: Shoes -> sho    
                        filtro: 'name',
                        p: this.descripcion
                    })
                    .then(response => (
                        this.listaDescription = response.data.response,
                        this.cargandoDescription = false,
                        // this.listades = false,
                        // this.nodescription = false,
                        this.receivercountDescription(this.listaDescription.length)                                 
                    ))
                    .catch(error => (
                        this.cargandoDescription = false,
                        this.listades = false,
                        this.nodescription = false
                    ))
                // }
                ,200);
            }  
        },
        receivercountDescription: function (value) {
            if(!value)
            {
                this.nodescription = true
            }
            else
            {
                this.nodescription = false
            }
        },
        setReceiverDescription: function (item) {
            this.codigoItem = item.codigo,
            this.descripcion = item.descripcion,
            this.codigoBarras = item.codigoProductoGs1,
            this.codigoSunat = item.codigoProductoSunat,
            // this.pesoProducto = 1,
            this.cantidad = 1,
            this.unidadMedidaCantidad = item.unidadMedida,
            this.listades = false,
            this.listaDescription = [],

            this.contadorDescripcion = this.descripcion.length
        },
        setReceiverUbigeo(item){
            if(item.direccion == null && item.ubigeo == null){
                this.direccionPartida = ''
                this.ubigeoPartida = ''
                this.listadesUbigeo = false
                this.$snotify.warning("No contiene direccion ni ubigeo","Atención")
            }else {
                this.direccionPartida = item.direccion
                this.ubigeoPartida = item.ubigeo
            }
            
            this.listadesUbigeo = false,
            this.listaDescriptionUbigeo = []
        },
        //listado de ubigeos prueba
        // reciveUibigeos(ubigeo){

        // },
        listarUbigeos(){
            axios
        .post(process.env.VUE_APP_API_URL + "establecimientos/listar", {
          token: this.$store.getters.userToken
        })
        .then(
          response => (
              this.listUbigeo = response.data.data,
              this.direciconInicialUbi()
          ))
        .catch(error => (console.log(error.response.data)
            ));
        },
        direciconInicialUbi(){
            this.selectedDirUbigeo = 0
            if(this.listUbigeo[0].ubigeo){
                this.ubigeoPartida = this.listUbigeo[0].ubigeo
            }
            this.mostrarUbigeo = true
            this.direccionPartida = this.listUbigeo[this.selectedDirUbigeo].direccion

        },
        //listado de ubigeos prueba
        searchUbigeo(){
        if(this.direccionPartida.length > 2 && !this.sinresultados){
            this.listaDescriptionUbigeo = []
            this.cargandoUbigeo = true,
            this.listadesUbigeo = true,
            this.nodescriptionUbigeo = false,
            axios
            .post(process.env.VUE_APP_API_URL + 'establecimientos/buscar',{
                token: this.$store.getters.userToken,
                search: this.direccionPartida              
            })
            .then(response =>(
                this.listaDescriptionUbigeo = response.data.response,
                this.filtrando = this.listaDescriptionUbigeo.filter(x=>x.direccion !=null),
                this.cargandoUbigeo = false,
                this.sinresultados = false
            ))
            .catch(error=>(
                // this.$snotify.warning("Sin resultados","Atención"),
                this.cargandoUbigeo = false,
                this.sinresultados = true
            ))
            }
        },
         cerrarresultados: function (value) {
             if(value == 1){
                this.mostrarubigeoTexto = false
                this.listarUbigeos();
             }else{
                this.mostrarubigeoTexto = true
            }       
        },
        searchDepartmentOrigen: function () {
            axios
                .post(process.env.VUE_APP_API_URL + 'ubigeo/departamento',{
                    token: this.$store.getters.userToken
                })
                .then(response => (
                    this.listDepartmentOrigen = response.data                       
                ))
                .catch(error => {})
        },
        searchProvinceOrigen: function () {
                this.provOrigenCargando = true
                axios
                .post(process.env.VUE_APP_API_URL + 'ubigeo/provincia',{
                    token: this.$store.getters.userToken,
                    department: this.departamentoSeleccionadoUbigeoOrigen
                })
                .then(response => (
                    this.provOrigenCargando = false,
                    this.listProvinceOrigen = response.data                       
                ))
                .catch(error => {})
        },
        searchDistrictOrigen: function (value) {
                this.distOrigenCargando = value   
                axios
                .post(process.env.VUE_APP_API_URL + 'ubigeo/distrito',{
                    token: this.$store.getters.userToken,
                    department: this.departamentoSeleccionadoUbigeoOrigen,
                    province: this.provinciaSeleccionadaUbigeoOrigen
                })
                .then(response => (
                    this.listDistrictOrigen = response.data,
                    this.ubigeoPartida = this.departamentoSeleccionadoUbigeoOrigen + this.provinciaSeleccionadaUbigeoOrigen + this.distritoSeleccionadoUbigeoOrigen.codDistrito,
                    this.prependUbigeoOrigen = this.distritoSeleccionadoUbigeoOrigen.nombre,
                    this.distOrigenCargando = false
                ))
                .catch(error => {})
        },
        searchDepartmentDestino: function () {
            axios
                .post(process.env.VUE_APP_API_URL + 'ubigeo/departamento',{
                    token: this.$store.getters.userToken
                })
                .then(response => (
                    this.listDepartmentDestino = response.data                       
                ))
                .catch(error => {})
        },
        searchProvinceDestino: function () {
                this.provDestinoCargando = true
                axios
                .post(process.env.VUE_APP_API_URL + 'ubigeo/provincia',{
                    token: this.$store.getters.userToken,
                    department: this.departamentoSeleccionadoUbigeoDestino
                })
                .then(response => (
                    this.listProvinceDestino = response.data,
                    this.provDestinoCargando = false                       
                ))
                .catch(error => {})
        },
        searchDistrictDestino: function (value) {
                this.distDestinoCargando = value  
                axios
                .post(process.env.VUE_APP_API_URL + 'ubigeo/distrito',{
                    token: this.$store.getters.userToken,
                    department: this.departamentoSeleccionadoUbigeoDestino,
                    province: this.provinciaSeleccionadaUbigeoDestino
                })
                .then(response => (
                    this.listDistrictDestino = response.data,
                    this.ubigeoLlegada = this.departamentoSeleccionadoUbigeoDestino + this.provinciaSeleccionadaUbigeoDestino + this.distritoSeleccionadoUbigeoDestino.codDistrito,
                    this.prependUbigeoDestino = this.distritoSeleccionadoUbigeoDestino.nombre,
                    this.distDestinoCargando = false  
                ))
                .catch(function (error){})
        },
        addRelacionado: function () {
            let item = {}
            let itemLocal = {}
            if(this.motivotraslado == '08'){
                if(this.modalidaddetraslado == '01'){
                    item.codigo = this.codigoRelacionadoImportacion,
                    item.numero = this.numeroRelacionado,
                    itemLocal.codigo = this.codigoRelacionadoImportacion,
                    itemLocal.numero = this.numeroRelacionado,
                    this.listCodRelacionadoPublico.forEach(function(element) {
                        if(element.codigo == item.codigo){
                            itemLocal.descripcion = element.descripcion
                        }
                    })
                }else if(this.modalidaddetraslado == '02'){
                    item.codigo = this.codigoRelacionado,
                    item.numero = this.numeroRelacionado,
                    itemLocal.codigo = this.codigoRelacionado,
                    itemLocal.numero = this.numeroRelacionado,
                    this.listCodRelacionadoPrivado.forEach(function(element) {
                        if(element.codigo == item.codigo){
                            itemLocal.descripcion = element.descripcion
                        }
                    })
                }
                
            }
            this.documentosRelacionadosLocal.push(itemLocal),
            this.documentosRelacionados.push(item)
            this.numeroRelacionado = ''
        },
        deleteRelacionado: function (index) {
            this.$swal({
                title: 'Eliminar Item',
                text: 'Seguro de eliminar este item ???',
                icon: 'error',
                buttons: true,
                dangerMode: true
            }).then((willDelete) => {
                if(willDelete){
                    this.documentosRelacionadosLocal.splice(index,1),
                    this.documentosRelacionados.splice(index,1)
                }else
                {

                }
            })
        },
        addQuickItem: function () {
            var parent = this;
            let val = 0;
            let item = {
                cantidad: '',
                codigoItem: '',
                unidadMedida: '',
                descripcion: '',
                adicional: {
                    precioVentaUnitario: '',
                    codigoProductoSunat: '',
                    codigoProductoGs1: '',
                    tipoAfectacionIgv: ''
                }
            }
            if(this.quickItems.length > 0){
                this.quickItems.forEach(function(element) {       
                    item.cantidad = element.cantidad
                    item.codigoItem = element.codigoProducto
                    item.codigoProductoSunat = element.codigoProductoSunat
                    item.unidadMedida = element.unidadMedidaCantidad
                    item.descripcion = element.descripcion
                    item.adicional.precioVentaUnitario = element.precioVentaUnitario
                    item.adicional.codigoProductoSunat = element.codigoProductoSunat
                    item.adicional.codigoProductoGs1 = element.codigoProductoGs1
                    item.adicional.tipoAfectacionIgv = element.tipoAfectacionIgv
                    if(element.unidadMedidaCantidad != 'ZZ'){
                        parent.items.push(item)
                    }
                    item = {
                        cantidad: '',
                        codigoItem: '',
                        unidadMedida: '',
                        descripcion: '',
                        adicional: {
                            precioVentaUnitario: '',
                            codigoProductoSunat: '',
                            codigoProductoGs1: '',
                            tipoAfectacionIgv: ''
                        }
                    }
                });
            }
        },
        addItem: function () {
            this.contadorDescripcion = 0
            let item ={
                adicional: {}
            }
            item.cantidad = this.cantidad
            item.codigoItem = this.codigoItem
            item.codigoProductoGs1 = this.codigoBarras
            item.codigoProductoSunat = this.codigoSunat
            item.unidadMedida = this.unidadMedidaCantidad
            item.descripcion = this.descripcion
            if(this.lote != '' || this.peso != '' || this.fvencimientoItem != ''){
                item.adicional.peso = this.peso
                item.adicional.lote = this.lote
                item.adicional.fechaVencimiento = this.fvencimientoItem
            }else{
                delete item.adicional
            }
            if(this.setIndex != -1){
                Object.assign(this.items[this.setIndex], item)
                this.$snotify.warning('Item Actualizado Correctamente', 'Atencion'),
                this.setIndex = -1
                this.setUpdateItem = false
            }else{
                this.items.push(item)
            }
            // this.items.push(item)
            this.cantidad = 1,
            this.codigoItem = '',
            this.unidadMedidaCantidad = 'NIU',
            this.descripcion = '',
            this.codigoProductoSunat = '',
            this.codigoBarras = '',
            this.codigoSunat = '',
            this.cargandoCodigoInterno = false,
            this.listCodigoInterno = false,
            this.cargandoDescription = false,
            this.listades = false,
            this.nodescription = false    
        },
        deleteItem: function (index) {
            this.$swal({
                title: 'Eliminar Item',
                text: 'Seguro de eliminar este item ???',
                icon: 'error',
                buttons: true,
                dangerMode: true
            }).then((willDelete) => {
                if(willDelete){
                    this.items.splice(index,1)
                }else
                {

                }
            })
        },
        validateFields: function () {
            const cantidadRegex = /^\d+(\.\d+)?$/;
            if(cantidadRegex.test(this.cantidad) && parseFloat(this.cantidad) > 0 &&  this.descripcion!=''){
                return true
            }else{
                return false
            }
        },
        validateGuide: function () {
            // if(this.modalidaddetraslado == '02'){
                if(this.motivotraslado != '18' && this.motivotraslado != '08'){
                    if(this.receptor.numero != ''){
                        if( this.pesoBruto != '' &&
                            this.ubigeoPartida != '' && 
                            this.ubigeoLlegada != '' && 
                            this.direccionPartida != '' && 
                            this.direccionLlegada != '' &&
                            this.items.length > 0){
                            if(this.modalidaddetraslado == '02'){
                                if(this.placaVehiculo.length >5){
                                    if(this.tipoVehiculo == '01' || this.tipoVehiculo == '02'){
                                        if(this.tipoVehiculo == '02'){
                                            if(this.recibeConductorSecundario.length > 0){
                                                if(this.tipodeguia == '0' ){
                                                    if(this.serieContingencia && this.numeroContingencia != ''){
                                                        return true;
                                                    }
                                                }else{
                                                    return true;
                                                }
                                            }
                                        }else if(this.tipoVehiculo == '01'){
                                            if(this.tipodeguia == '0' ){
                                                if(this.serieContingencia && this.numeroContingencia != ''){
                                                    return true;
                                                }
                                            }else{
                                                    return true;
                                                }
                                        }
                                    
                                    }
                                }
                            }else if(this.modalidaddetraslado == '01'){
                                if(this.numeroRucTransportista !='' && this.denominacionTransportista !=''){
                                    if(this.tipodeguia == '0' ){
                                        if(this.serieContingencia && this.numeroContingencia != ''){
                                            return true;
                                        }
                                    }else{
                                        return true;
                                    }
                                }
                                
                            }
                        }
                    }
                }else if(this.motivotraslado == '18'){
                    if( this.pesoBruto != '' &&
                        this.ubigeoPartida != '' && 
                        this.ubigeoLlegada != '' && 
                        this.direccionPartida != '' && 
                        this.direccionLlegada != '' &&
                        this.items.length > 0){
                        if(this.modalidaddetraslado == '02'){
                            if(this.placaVehiculo.length >5){
                                if(this.tipoVehiculo == '01' || this.tipoVehiculo == '02'){
                                    if(this.tipoVehiculo == '02'){
                                        if(this.recibeConductorSecundario.length > 0){
                                            if(this.tipodeguia == '0' ){
                                                if(this.serieContingencia && this.numeroContingencia != ''){
                                                    return true;
                                                }
                                            }else{
                                                return true;
                                            }
                                        }
                                    }else if(this.tipoVehiculo == '01'){
                                        if(this.tipodeguia == '0' ){
                                            if(this.serieContingencia && this.numeroContingencia != ''){
                                                return true;
                                            }
                                        }else{
                                                return true;
                                            }
                                    }
                                
                                }
                            }
                        }else if(this.modalidaddetraslado == '01'){
                            if(this.numeroRucTransportista !='' && this.denominacionTransportista !=''){
                                if(this.tipodeguia == '0' ){
                                    if(this.serieContingencia && this.numeroContingencia != ''){
                                        return true;
                                    }
                                }else{
                                    return true;
                                }
                            }
                            
                        }
                    }
                }else if(this.motivotraslado == '08'){
                    if(this.receptor.numero != ''){
                        if( this.pesoBruto != '' &&
                            this.ubigeoPartida != '' && 
                            this.ubigeoLlegada != '' && 
                            this.direccionPartida != '' && 
                            this.direccionLlegada != '' &&
                            this.numeroRucTransportista !='' &&
                            this.denominacionTransportista !='' &&
                            this.documentosRelacionados.length > 0 &&
                            this.numeroBultos != '' &&
                            this.codigoPuerto != '' &&
                            this.items.length > 0){
                            if(this.modalidaddetraslado == '02'){
                                if(this.placaVehiculo.length >5){
                                    if(this.tipoVehiculo == '01' || this.tipoVehiculo == '02'){
                                        if(this.tipoVehiculo == '02'){
                                            if(this.recibeConductorSecundario.length > 0){
                                                if(this.tipodeguia == '0' ){
                                                    if(this.serieContingencia && this.numeroContingencia != ''){
                                                        return true;
                                                    }
                                                }else{
                                                    return true;
                                                }
                                            }
                                        }else if(this.tipoVehiculo == '01'){
                                            if(this.tipodeguia == '0' ){
                                                if(this.serieContingencia && this.numeroContingencia != ''){
                                                    return true;
                                                }
                                            }else{
                                                    return true;
                                                }
                                        }
                                    
                                    }
                                }
                            }else if(this.modalidaddetraslado == '01'){
                                if(this.numeroRucTransportista !='' && this.denominacionTransportista !=''){
                                    if(this.tipodeguia == '0' ){
                                        if(this.serieContingencia && this.numeroContingencia != ''){
                                            return true;
                                        }
                                    }else{
                                        return true;
                                    }
                                }
                                
                            }
                        }
                    }
                }
                    
            // }else if(this.modalidaddetraslado == '01'){
            //     if(this.receptor.numero != '' &&
            //         this.pesoBruto != '' &&
            //         this.ubigeoPartida != '' && 
            //         this.ubigeoLlegada != '' && 
            //         this.direccionPartida != '' && 
            //         this.direccionLlegada != '' &&
            //         this.numeroRucTransportista !='' &&
            //         this.denominacionTransportista !='' &&
            //         this.items.length > 0){
            //         if(this.tipodeguia == '0' ){
            //             if(this.serieContingencia && this.numeroContingencia != ''){
            //             return true;
            //             }
            //         }else{
            //             return true;
            //         }
            //     }
                
            // }         
        },
        enableFieldsReceptorCliente: function () {
            this.norec = false,
            this.habilitado = false
        },
        setReceiver: function (item) {
            let captureUbigeo = '';
            this.receptor.numero = item.idReceptor,
            this.receptor.tipo = item.tipo,
            this.receptor.razonSocial = item.razonSocial
            if(item.direccionReferencia != null & item.direccionReferencia != ''){
                this.receptor.direccion = item.direccionReferencia
                this.direccionLlegada = item.direccionReferencia
            }
            this.direcciones = item.direcciones,
            this.listarec = false
            if(item.direcciones){
                if(this.receptor.direccion == this.direccionLlegada){
                    item.direcciones.forEach(function(element){
                        if(element.direccion == item.direccionReferencia){
                           if(element.ubigeo != null && element.ubigeo !=''){
                                captureUbigeo = element.ubigeo
                           }
                        } 
                    })   
                }
                this.ubigeoLlegada = captureUbigeo
            }  
        },
        setReceiverProveedor(item){
            this.numeroDocumentoProveedor = item.idReceptor,
            this.tipoDocumentoProveedor = item.tipo,
            this.denominacionProveedor = item.razonSocial,
            this.direccionProveedor = item.direccionReferencia,
            this.listarecProveedor = false
        },
        setReceiverTransportista: function (item) {
            this.numeroRucTransportista = item.idReceptor,
            this.tipoDocumentoTransportista = item.tipo,
            this.denominacionTransportista = item.razonSocial,
            this.listarecTransportista = false
        },
        setReceiverConductor: function (item) {
        this.numDoc = item.nroDocumento,
        this.nombreConductor = item.nombres,
        this.apellidoConductor = item.apellidos,
        this.numLicencia = item.nroLicencia,

        // cerrando lista de documentos
        this.listaConductor = false;
        },
        getReceivers: function (value) {
           if(this.receptor.numero.length>3){
               this.cargandoreceptor = true
               this.listarec = false
               this.norec = false
               axios
                .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros',{
                    token: this.$store.getters.userToken,
                    q: this.receptor.numero,
                    tipoRec: this.tipoDocumento
                })
                .then(response => (
                    this.listaReceptores = response.data,
                    this.cargandoreceptor = false,
                    this.listarec = true,
                    this.receivercount(this.listaReceptores.length)                                 
                ))
                .catch(function (error){
                    this.cargandoreceptor = false
                    this.listarec = false
                })
            }            
        },
        getReceiversProveedor: function () {
           if(this.numeroDocumentoProveedor.length>3){
               this.listarecProveedor = true
               this.listarecProveedor = false
               this.norecProveedor = false
               axios
                .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros',{
                    token: this.$store.getters.userToken,
                    q: this.numeroDocumentoProveedor,
                    tipoRec: this.tipoDocumentoProveedor
                })
                .then(response => (
                    this.listaReceptoresProveedores = response.data,
                    this.cargandoProveedor = false,
                    this.listarecProveedor = true,
                    this.receivercount(this.listaReceptoresProveedores.length)                                 
                ))
                .catch(function (error){
                    this.cargandoProveedor = false
                    this.listarecProveedor = false
                })
            }            
        },
        getReceiversTransportista: function () {
           if(this.numeroRucTransportista.length > 3){
               this.cargandoreceptorTransportista = true
               this.listarecTransportista = false
               this.norecTransportista = false
               axios
                .post(process.env.VUE_APP_API_URL + 'receptores/lista',{
                    token: this.$store.getters.userToken,
                    q: this.numeroRucTransportista,
                    tipoRec: this.tipoDocumentoTransportista
                })
                .then(response => (
                    this.listaTransportista = response.data,
                    this.cargandoreceptorTransportista = false,
                    this.listarecTransportista = true,
                    this.receivercountTransportista(this.listaTransportista.length)                                 
                ))
                .catch(function (error){
                    this.cargandoreceptorTransportista = false
                    this.listarecTransportista = false
                })
            }            
        },
        getReceiversRazSocial: function () {
           if(this.denominacionTransportista.length > 3){
               this.cargandoreceptorTransportista = true
               this.listarecTransportista = false
               this.norecTransportista = false
               axios
                .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros/razonsocial',{
                    token: this.$store.getters.userToken,
                    q: this.denominacionTransportista,
                })
                .then(response => (
                    this.listaTransportista = response.data,
                    this.cargandoreceptorTransportista = false,
                    this.listarecTransportista = true,
                    this.receivercountTransportista(this.listaTransportista.length)                                 
                ))
                .catch(function (error){
                    this.cargandoreceptorTransportista = false
                    this.listarecTransportista = false
                })
            }            
        },

        receivercount: function (value){
            if(!value)
            {
                this.norec = true
                this.norecProveedor = true
                setTimeout(() => this.searchDNI(),1000);       
            }
            else
            {
                this.norec = false
                this.norecProveedor = false
            }
        },
        searchDNI(){
            this.cargandoreceptor = true
            axios
            .get(process.env.VUE_APP_API_URL +'v2/dni',{
                params:{
                    token: this.$store.getters.userToken,
                    dni: this.receptor.numero
                }
            })
            .then(response => (
                this.listadni = response.data,
                this.cargandoreceptor = false,
                this.receivedni(this.listadni)
            ))
            .catch(error => (
                this.cargandoreceptor = false,
                this.mostrardni = false
            ))    
            
        },
        receivedni: function (value){
            if(!value)
            {
                this.mostrardni = false
            }
            else
            {
                this.mostrardni = true,
                this.setReceiverdni(this.listadni)
            }
        },
        setReceiverdni(item){
            this.receptor.razonSocial = item.nombre
            this.mostrardni = false
            this.listarec = false
            this.listaReceptores = []
        },
        receivercountTransportista: function (value){
            if(!value)
            {
                this.norecTransportista = true
            }
            else
            {
                this.norecTransportista = false
            }
        },
        receivercountConductor: function (value){
            if(value == 0)
            {
                this.norecConductor = true
            }
            else
            {
                this.norecConductor = false
            }
        },
        customFormatter(date) {
            return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
        initDates: function () {
            let r1 = {
                from: this.$moment().subtract(50000,"years"),
                to: this.$moment().subtract(2,"days")
            };
            let r2 = {
                from: this.$moment().add(0,"days"),
                to: this.$moment().add(60000,"years")
            };
            this.diasnopermitidos.ranges.splice(r1);
            this.diasnopermitidos.ranges.splice(r2);
            this.diasnopermitidos.ranges.push(r1);
            this.diasnopermitidos.ranges.push(r2);

            let r1BienesTrans = {
                from: this.$moment().subtract(50000,"years"),
                to: this.$moment().subtract(1,"days")
            };
            let r2BienesTrans = {
                from: this.$moment().add(60000,"years"),
                to: this.$moment().add(60000,"years")
            };
            this.diasnopermitidosBienesTrans.ranges.splice(r1BienesTrans);
            this.diasnopermitidosBienesTrans.ranges.splice(r2BienesTrans);
            this.diasnopermitidosBienesTrans.ranges.push(r1BienesTrans);
            this.diasnopermitidosBienesTrans.ranges.push(r2BienesTrans);

            this.currentdate = this.$moment().format('YYYY-MM-DD HH:mm:ss')
            
        },
        diasFechaTrasporteGr: function () {
            let r1 = {
                from: this.$moment().subtract(50000,"years"),
                to: this.$moment().subtract(2,"days")
            };
            let r2 = {
                from: this.$moment().add(60000,"days"),
                to: this.$moment().add(60000,"years")
            };
            this.diasFechaTrasporte.ranges.splice(r1);
            this.diasFechaTrasporte.ranges.splice(r2);
            this.diasFechaTrasporte.ranges.push(r1);
            this.diasFechaTrasporte.ranges.push(r2);
            this.currentdateTransporte = this.$moment().format('YYYY-MM-DD')
        },
        enableFieldsReceptorConductor: function () {
            this.norecConductor = false,
            this.habilitado = false
        },
        sendGuide: function () {
            this.cargandoemision = true
            this.referralGuide.token = this.$store.getters.userToken
            if(this.indexSerie == 0){
                this.referralGuide.serie = this.listaSeries[0]
            }else{
                this.referralGuide.serie = this.listaSeries[this.indexSerie]
            }
            if(this.tipodeguia == '09'){
                this.referralGuide.tipoDocumentoGuia = this.tipodeguia
            }else if(this.tipodeguia == '0'){
                this.tipodeguia = '09'
                this.referralGuide.tipoDocumentoGuia = this.tipodeguia
                this.referralGuide.serie = this.serieContingencia 
                this.referralGuide.numero = this.numeroContingencia 
            }
            this.referralGuide.motivoTraslado = this.motivotraslado,
            this.referralGuide.unidadPesoBruto = 'KGM'
            this.referralGuide.pesoBrutoTotal = this.pesoBruto,
            this.referralGuide.modalidadTraslado = this.modalidaddetraslado
            this.referralGuide.adicional.descripcionMotivoTraslado = this.descripcionMotivoTraslado
            this.referralGuide.adicional.serieF = this.bufferInvoice.serie
            this.referralGuide.adicional.numeroF= this.bufferInvoice.numero
            this.referralGuide.adicional.idFactura = this.bufferInvoice.idFactura
            this.referralGuide.adicional.informacionAdicional = this.informacionAdicional
            if(this.femision != ''){
                if(this.$moment(this.femision).format('YYYY-MM-DD') == this.$moment(this.currentdate).format('YYYY-MM-DD')){
                     //si la fecha es == a hoy, no se envia fecha
                       delete this.referralGuide.fechaEmision;
                }else{
                    //si la fecha es diferente de hoy(fecha de ayer), se envia.
                    this.referralGuide.fechaEmision = this.$moment(this.femision).format('YYYY-MM-DD HH:mm:ss')
                }
            }
            if(this.fechaInicioTraslado != ''){
                this.referralGuide.fechaInicioTraslado = this.$moment(this.fechaInicioTraslado).format('YYYY-MM-DD HH:mm:ss')
            }else{
                this.referralGuide.fechaInicioTraslado = this.$moment().format('YYYY-MM-DD HH:mm:ss')
            }
            this.referralGuide.ubigeoPartida = this.ubigeoPartida
            this.referralGuide.direccionPartida = this.direccionPartida.substr(0,100)
            this.referralGuide.ubigeoLlegada = this.ubigeoLlegada
            this.referralGuide.direccionLlegada = this.direccionLlegada.substr(0,100)
            if(this.motivotraslado == '01'|| this.motivotraslado == '05' || this.motivotraslado == '06' || this.motivotraslado == '14'){
                if(this.modalidaddetraslado == '01'){
                    this.referralGuide.adicional.observaciones = this.observaciones
                    this.referralGuide.adicional.tipoDocumentoTransportista = this.tipoDocumentoTransportista
                    if(this.denominacionTransportista){
                        this.referralGuide.adicional.denominacionTransportista = this.denominacionTransportista
                    }
                    if(this.tipoDocumentoTransportista == '0'){
                        this.referralGuide.adicional.numeroRucTransportista = '-'
                    }else{
                        this.referralGuide.adicional.numeroRucTransportista = this.numeroRucTransportista
                    }     
                }else{
                    if(this.documentosRelacionados.length > 0){
                        this.referralGuide.documentosRelacionados = this.documentosRelacionados
                    }
                    this.referralGuide.adicional.observaciones = this.observaciones
                    this.referralGuide.adicional.descripcionMotivoTraslado = this.descripcionMotivoTraslado
                    this.referralGuide.adicional.numeroContenedor = this.numeroContenedor
                    // this.referralGuide.adicional.numeroPlacaVehiculo = this.numeroPlacaVehiculo
                    // this.referralGuide.adicional.tipoDocumentoConductor = this.documentoConductor
                    // this.referralGuide.adicional.numeroDocumentoConductor = this.numeroDocumentoConductor
                    // this.referralGuide.adicional.nombresApellidosConductor = this.nombresApellidosConductor
                }
            }else if(this.motivotraslado == '02'){
                this.referralGuide.adicional.tipoDocumentoTransportista = this.tipoDocumentoTransportista;
                this.referralGuide.adicional.numeroRucTransportista = this.numeroRucTransportista;
                this.referralGuide.adicional.denominacionTransportista = this.denominacionTransportista;
                //PROVEEDOR
                this.referralGuide.adicional.tipoDocumentoProveedor = this.tipoDocumentoProveedor;
                this.referralGuide.adicional.numeroDocumentoProveedor = this.numeroDocumentoProveedor;
                this.referralGuide.adicional.denominacionProveedor = this.denominacionProveedor;
                this.referralGuide.adicional.direccionProveedor = this.direccionProveedor;
            }else if(this.motivotraslado == '13'){
                    this.referralGuide.adicional.observaciones = this.observaciones
                    this.referralGuide.adicional.descripcionMotivoTraslado = this.descripcionMotivoTraslado
                    // this.referralGuide.adicional.serieRemisionDadaBaja": "EG01",
                    // this.referralGuide.adicional.numeroRemisionDadaBaja": 10,
                    // this.referralGuide.adicional.codigoRemisionDadaBaja": "09",
                    // this.referralGuide.adicional.tipoRemisionDadaBaja": "Guia de remision",
                    // this.referralGuide.adicional.numeroPlacaVehiculo = this.numeroPlacaVehiculo
                    this.referralGuide.adicional.numeroRucTransportista = this.numeroRucTransportista
                    // this.referralGuide.adicional.tipoDocumentoConductor = this.documentoConductor
                    // this.referralGuide.adicional.numeroDocumentoConductor = this.numeroDocumentoConductor
                    if(this.denominacionTransportista){
                        this.referralGuide.adicional.denominacionTransportista = this.denominacionTransportista
                    }
            }else if(this.motivotraslado == '04'){
                    this.referralGuide.adicional.observaciones = this.observaciones
                    this.referralGuide.adicional.descripcionMotivoTraslado = this.descripcionMotivoTraslado
                    this.referralGuide.adicional.numeroContenedor = this.numeroContenedor
                    
                    // this.referralGuide.adicional.tipoDocumentoConductor = this.documentoConductor
                    
                    if(this.denominacionTransportista){
                        this.referralGuide.adicional.denominacionTransportista = this.denominacionTransportista
                    }
                    if(this.modalidaddetraslado == '02'){ // Privado
                        // this.referralGuide.adicional.numeroPlacaVehiculo = this.numeroPlacaVehiculo
                    }else if(this.modalidaddetraslado == '01'){ // Publico
                        // this.referralGuide.adicional.numeroPlacaVehiculo = this.numeroPlacaVehiculo
                        this.referralGuide.adicional.numeroRucTransportista = this.numeroRucTransportista
                    }
                    // this.referralGuide.adicional.numeroDocumentoConductor = this.numeroDocumentoConductor
                    this.referralGuide.adicional.nombresApellidosConductor = this.nombresApellidosConductor
            }else if(this.motivotraslado == '08'){
                    // this.referralGuide.adicional.numeroPlacaVehiculo = this.numeroPlacaVehiculo
                    // this.referralGuide.adicional.tipoDocumentoConductor = this.documentoConductor
                    // this.referralGuide.adicional.numeroDocumentoConductor = this.numeroDocumentoConductor
                    if(this.documentosRelacionados.length > 0){
                        this.referralGuide.documentosRelacionados = this.documentosRelacionados
                    }
                    this.referralGuide.adicional.observaciones = this.observaciones
                    this.referralGuide.adicional.descripcionMotivoTraslado = this.descripcionMotivoTraslado
                    this.referralGuide.adicional.numeroContenedor = this.numeroContenedor
                    this.referralGuide.adicional.numeroBultos = parseFloat(this.numeroBultos)
                    this.referralGuide.adicional.codigoPuerto = this.codigoPuerto
                    this.referralGuide.adicional.numeroDocumentoProveedor = this.numeroDocumentoProveedor
                    this.referralGuide.adicional.tipoDocumentoProveedor = this.tipoDocumentoProveedor
                    this.referralGuide.adicional.denominacionProveedor = this.denominacionProveedor
                    if(this.tipoDocumentoTransportista == '0'){
                        this.referralGuide.adicional.numeroRucTransportista = '-'
                    }else{
                        this.referralGuide.adicional.numeroRucTransportista = this.numeroRucTransportista
                    } 
                    this.referralGuide.adicional.tipoDocumentoTransportista = this.tipoDocumentoTransportista
                    if(this.denominacionTransportista){
                        this.referralGuide.adicional.denominacionTransportista = this.denominacionTransportista
                    }
                    this.referralGuide.adicional.numeroVehiculoSecundario = this.numeroVehiculoSecundario
            }else if(this.motivotraslado == '18'){
                this.referralGuide.adicional.tipoDocumentoTransportista = this.tipoDocumentoTransportista;
                this.referralGuide.adicional.numeroRucTransportista = this.numeroRucTransportista;
                this.referralGuide.adicional.denominacionTransportista = this.denominacionTransportista;

            }
            if(this.receptor.tipo == ''){
                this.referralGuide.receptor.tipo = this.tipoDocumento.toString()
                this.referralGuide.receptor.razonSocial  = this.receptor.razonSocial
                this.referralGuide.receptor.direccion  = this.receptor.direccion
            }else{
                this.referralGuide.receptor.tipo = this.receptor.tipo.toString()
                this.referralGuide.receptor.razonSocial  = this.receptor.razonSocial
                this.referralGuide.receptor.direccion  = this.receptor.direccion
            }
            if(this.tipoDocumento == 0){
                this.referralGuide.receptor.nro = '-'
            }else{
                this.referralGuide.receptor.nro = this.receptor.numero.toString()
            }
            
            if(this.recibeConductorSecundario.length > 0){
                this.referralGuide.adicional.conductores = this.recibeConductorSecundario; // AGREGANDO CONDUCTORES
            }else{
                delete this.referralGuide.adicional.conductores
            }
                this.referralGuide.adicional.datosTraslado.indicadorTrasladoVehiculoM1L = this.conVehiculo; //categoría M1 o L
                
            if(this.modalidaddetraslado == '02'){
                this.referralGuide.adicional.vehiculoPrincipal.numeroPlacaVehiculo = this.placaVehiculo;
                if(this.numCirculacionVehiculo !=''){
                    this.referralGuide.adicional.vehiculoPrincipal.numeroCirculacionVehiculo = this.numCirculacionVehiculo;
                }else{
                    delete this.referralGuide.adicional.vehiculoPrincipal.numeroCirculacionVehiculo;
                }
               
            }else{
                delete this.referralGuide.adicional.vehiculoPrincipal;
            }
            if(this.recibeVehiculoSecundario.length >0){
                // this.recibeVehiculoSecundario.forEach(el => delete el.codEdicion)
                // this.recibeVehiculoSecundario.forEach(el => delete el.nomEntidadEmisora)
                this.referralGuide.adicional.vehiculosSecundario = this.recibeVehiculoSecundario; 
            }
             if(this.modalidaddetraslado == '01'){ //publico
                if(this.motivotraslado == '01'){ //tipo guia venta
                    if(this.fechaEntregaBienesTransportista !=''){
                        this.referralGuide.adicional.fechaEntregaBienesTransportista = this.$moment(this.fechaEntregaBienesTransportista).format('YYYY-MM-DD')
                    }else{
                        this.referralGuide.adicional.fechaEntregaBienesTransportista = this.$moment().format('YYYY-MM-DD')
                    }
                }
                this.referralGuide.adicional.tipoDocumentoTransportista = this.tipoDocumentoTransportista
            }
            this.referralGuide.adicional.username = this.$store.getters.userData.username
            this.referralGuide.items = this.items
                axios
                .post(process.env.VUE_APP_API_URL + 'guiaremitente/emitir', this.referralGuide, config)
                .then(response => {
                    this.cargandoemision = false,
                    this.$snotify.success(response.data.msg, 'Éxito'),
                    this.backEmision(response.data.response.idGuiaRemitente),
                    this.initGre()
                })
                .catch(error => {
                    this.cargandoemision = false;
                    this.previwEmit = true;
                    if (error.response && error.response.status === 500) {
                        // this.modalError500 = true
                        this.errorJson = error.response.data;
                    }
                    this.catchError(error.response.data);
                })
        },
        refreshPage() {
            this.$router.go(0);
        },
        async copyJsonToClipboard() {
            try {
                await navigator.clipboard.writeText(JSON.stringify(this.errorJson));
                this.$snotify.success('JSON copiado al portapapeles', 'Éxito');
            } catch (err) {
                this.$snotify.error('No se pudo copiar el JSON al portapapeles', 'Error');
            }
        },
        catchError: function (value) {
            let errorgateway = ''
            let errormessage = ''
            let errordescription = ''
            value.msg ? errorgateway = value.msg: errorgateway = ''
            value.response.message ? errormessage = value.response.message: errormessage = ''
            value.response.description ? errordescription = value.response.message: errordescription = ''
            // this.$snotify.error(errordescription + ' - ' + errormessage + ' - ' + errorgateway, 'Error')
            this.errorGuia = true
            this.error1 = value.msg
            this.error2 = value.response.message
            this.error3 = value.response.description
        },
        initGre: function () {
            this.informacionAdicional = '',
            this.tipoDocumentoTransportista = '6',
            this.serieContingencia = '',
            this.numeroContingencia = '',
            this.tipodeguia = '09',
            this.bloquearCampoConductor = false,
            this.bloquearCampoVehiSecundario = false,
            this.placaVehiculo = '',
            this.numCirculacionVehiculo = '',
            this.codEntidadEmisora = 0,
            this.codEntidadEmisoraSecundario = 0,
            this.numAutorizacionVehiculo = '',
            this.recibeVehiculoSecundario = [],
            this.recibeConductorSecundario = [],
            this.documentosRelacionados = [],
            this.numeroBultos = '',
            this.codigoPuerto = '',
            this.documentosRelacionadosLocal = [],
            this.items = [],
            this.receptor.numero = '',
            this.receptor.razonSocial = '',
            this.receptor.direccion = '',
            this.serie = '',
            this.ubigeoPartida = '',
            this.prependUbigeoOrigen = '',
            this.ubigeoLlegada = '',
            this.prependUbigeoDestino = '',
            this.direccionPartida = '',
            this.direccionLlegada = '',
            this.pesoBruto = '',
            this.descripcionMotivoTraslado = '',
            this.numeroContenedor = '',
            this.observaciones = '', 
            this.cantidad  = 1,
            this.codigoItem = '',
            this.descripcion = '',
            this.numeroRucTransportista = '',
            this.denominacionTransportista = '',
            this.previwEmit = true,
            this.numeroPlacaVehiculo = '',
            this.numeroDocumentoConductor = '',
            this.nombresApellidosConductor = '',
            this.modalidaddetraslado = '01',
            this.conVehiculo = false,
            this.motivotraslado = '01',
            this.tipoDocumento = 6,
            this.fechaInicioTraslado = '',
            this.femision = '',
            this.referralGuide = {
                token: '',
                serie: '',
                tipoDocumentoGuia: '',
                motivoTraslado: '',
                pesoBrutoTotal: '',
                unidadPesoBruto: '',
                modalidadTraslado: '',
                fechaInicioTraslado: '',
                ubigeoLlegada: '',
                direccionLlegada: '',
                ubigeoPartida: '',
                direccionPartida: '',
                adicional: {
                    vehiculoPrincipal:{
                        numeroPlacaVehiculo:''
                    }, 
                    datosTraslado:{
                        indicadorTrasladoVehiculoM1L:''
                    }
                },
                receptor: {},
                items: [
                    {
                        cantidad: '',
                        descripcion: '',
                        codigoItem: '',
                        unidadMedida: ''
                    }
                ]
            },
            this.initDates(),
            this.diasFechaTrasporteGr(),
            this.file = null,
            this.action.reset = true
            // this.changeTab(1),
            GuiaRemisionConsulta.listGuide()
        },
        changeTab: function (value){
            this.$emit("tabindex", value);
        },
        changeDirection: function() {
        this.verDirecciones = !this.verDirecciones;
        },
        changeDirectionUbigeo(){
            this.verDireccionesLlegada = !this.verDireccionesLlegada;
        },
        setDirection: function(value) {
        this.receptor.direccion = value.direccion,
        this.verDirecciones = false
        },
        setDirectionUbigeo: function(value) {
        this.direccionLlegada = value.direccion
        if(value.ubigeo != null && value.ubigeo !=''){
            this.ubigeoLlegada = value.ubigeo
        }
        this.verDireccionesLlegada = false
        },
        pitcherReceiver: function(value) {
            if (value === 1) {
                if (this.receptor.numero.length >= 3) {
                    setTimeout(() => this.getReceivers(), 200);
                } else if (this.receptor.numero.length <= 2) {
                    this.initReceptor();
                }
            }
            if (value === 2) {
                if (this.receptor.razonSocial.length >= 3) {
                    setTimeout(() => this.getReceiversByRSocial(), 200);
                }else if (this.receptor.razonSocial.length <= 2) {
                    // this.initReceptor();
                }
            }
            if (value === 3) {
                if (this.numeroDocumentoProveedor.length >= 3) {
                    setTimeout(() => this.getReceiversProveedor(), 200);
                } else if (this.numeroDocumentoProveedor.length <= 2) {
                    this.initReceptorProveedor();
                }
            }
        },
        reciverTrasportista(value){
            if (value === 1) {
                if (this.numeroRucTransportista.length >= 3) {
                    setTimeout(() => this.getReceiversTransportista(), 200);
                } else if (this.numeroRucTransportista.length <= 2) {
                    this.numeroRucTransportista = ''
                }
            }
            if (value === 2) {
                if (this.denominacionTransportista.length >= 3) {
                    setTimeout(() => this.getReceiversRazSocial(), 200);
                }else if (this.denominacionTransportista.length <= 2) {
                   this.denominacionTransportista = ''
                }
            }
        },
        initReceptor: function() {
            (this.receptor = {
            numero: "",
            tipo: "",
            direccion: "",
            nombre: "",
            direccionReferencia: ""
            }),
                    (this.listaReceptores = []),
                    (this.cargandoreceptor = false);
        },
        initReceptorProveedor: function() {
            this.denominacionProveedor = '',
            this.numeroDocumentoProveedor = '',
            this.direccionProveedor = '',
            this.tipoDocumentoProveedor = 6,
            (this.listaReceptoresProveedores = []),
            (this.cargandoProveedor = false);
        },
        getReceiversByRSocial: function() {
        if (this.receptor.razonSocial.length >= 3) {
          this.cargandoreceptor = true;
          this.listarec = true;
          this.norec = false;
          axios
            .post(process.env.VUE_APP_API_URL +"receptores/listaconterceros/razonsocial",{
                token: this.$store.getters.userToken,
                q: this.receptor.razonSocial
                })
                .then(response => (
                    this.listaReceptores = response.data,
                    this.cargandoreceptor = false,
                    this.receivercount(this.listaReceptores.length)
                ))
                .catch(error => (
                    this.cargandoreceptor = false
                ));
        }else {
          (this.listaReceptores = []), (this.cargandoreceptor = false);
        }
      },
      closeList(){
          this.listarec = false
          this.cargandoreceptor = false
      },
      search(){
            if(this.descripcion.length > 1){
            this.mostrarListaProduc = true
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                token: this.$store.getters.userToken,
                filtro: 'name',
                p: this.descripcion
            })
            .then(response=>(
                this.ListProductos = response.data.response,
                this.searchItems = true,
                this.ListProductos.forEach(function(element) {
                        element.cantidad = '',
                        element.boleta = 'boleta'
                    }),
                this.listaDescription = [],
                this.listades = false,
                this.mostrarListaProduc = false
            ))
            .catch(error=>(
               console.log(this.$snotify.warning("Debe agregar una descripción","Cuidado"))
            ))
            }       
        },
        cargarItems(){
            let valor = false
            this.ListProductos.forEach(function(element){
                if(element.cantidad > 0){
                    valor = true
                }
            })
            if(valor){
                this.subirItems = true
                this.itemsModal = this.ListProductos.filter(x => x.cantidad > 0)
                this.itemsEX = this.itemsModal
                this.action.g = true 
                this.searchItems = false
            }else{
                this.$snotify.warning("Debe agregar una cantidad","Cuidado")
            }
        },
        cerrarmodal(value){
         this.errorGuia = value
        },
        mayus(){
            this.numeroPlacaVehiculo = this.numeroPlacaVehiculo.toUpperCase();
            this.numeroDocumentoConductor = this.numeroDocumentoConductor.toUpperCase();
            this.placaVehiculoSecundario = this.placaVehiculoSecundario.toUpperCase();
            this.placaVehiculo = this.placaVehiculo.toUpperCase();
            // this.numCirculacionVehiculoSecundario = this.numCirculacionVehiculoSecundario.toUpperCase();
            this.numCirculacionVehiculo = this.numCirculacionVehiculo.toUpperCase();
            
        },
        validaPeso(event) {
              const keyCode = event.keyCode || event.which;
               if (keyCode === 8 || keyCode === 46) {
                    return;
                }
          const regex = /^[0-9]*\.?[0-9]{0,2}$/; 
            // Verifica si el carácter presionado es un carácter especial
             if (!regex.test(event.target.value + event.key)) {
                // Si es un carácter especial, evita el evento keydown
                event.preventDefault();
            }
        },
        handleKeyDown(event) {
              const keyCode = event.keyCode || event.which;
               if (keyCode === 8 || keyCode === 46) {
                    return;
                }
             // Expresión regular que identifica los caracteres especiales
            const regex = /^[0-9\b]+$/; 
            // Verifica si el carácter presionado es un carácter especial
             if (!regex.test(event.key)) {
                // Si es un carácter especial, evita el evento keydown
                event.preventDefault();
            }
        },
        handleKeyDown2(event) {
             // Expresión regular que identifica los caracteres especiales
            const regex = /^[a-zA-Z0-9]+$/; 
            // Verifica si el carácter presionado es un carácter especial
             if (!regex.test(event.key)) {
                // Si es un carácter especial, evita el evento keydown
                event.preventDefault();
            }
        },
        numeroPunto(event){
             const keyCode = event.keyCode || event.which;
               if (keyCode === 8 || keyCode === 46) {
                    return;
                }
        // Expresión regular que identifica los caracteres especiales
            const regex = /^[\d.]+$/; 
            // Verifica si el carácter presionado es un carácter especial
             if (!regex.test(event.key)) {
                // Si es un carácter especial, evita el evento keydown
                event.preventDefault();
            }
        },
        validaSoloAlfaNum(event) {
             // Expresión regular que identifica los caracteres especiales
            const regex = /^[a-zA-Z0-9]+$/; 
            // Verifica si el carácter presionado es un carácter especial
             if (!regex.test(event.key)) {
                // Si es un carácter especial, evita el evento keydown
                event.preventDefault();
            }
        },
        limpiarTextoPegado(event) {
            event.preventDefault(); // Evita el pegado directo sin filtrar
            let texto = (event.clipboardData || window.clipboardData).getData("text"); 
            // Elimina los caracteres no permitidos (ej. "-")
            texto = texto.replace(/[^a-zA-Z0-9]/g, "");  
            // Asigna el texto limpio a la variable vinculada con v-model
                this.placaVehiculo = texto
        },
        limpiarTextoPegadoSecundario(event) {
            event.preventDefault(); // Evita el pegado directo sin filtrar
            let texto = (event.clipboardData || window.clipboardData).getData("text"); 
            // Elimina los caracteres no permitidos (ej. "-")
            texto = texto.replace(/[^a-zA-Z0-9]/g, "");  
            // Asigna el texto limpio a la variable vinculada con v-model
                this.placaVehiculoSecundario = texto; 
        },
        validarConductor(){
            if(this.numDoc !='' && 
                this.nombreConductor !='' &&
                this.apellidoConductor !='' &&
                this.apellidoConductor !='' &&
                this.numLicencia !=''){
                return true;
            }else{
                return false;
            }
        },
        pitcherReceiverRemitente: function(value) {
            if (value === 1) {
                if (this.remitente.numero.length >= 3) {
                    setTimeout(() => this.getReceiversRemitente(), 200);
                } else if (this.remitente.numero.length <= 2) {
                    this.initReceptor();
                }
            }
            // conductor
            if (value === 2) {
                if (this.numDoc.length >= 3) {
                    setTimeout(() => this.getReceiverConductor(), 200);
                }
            }
            //Vehiculos
            if (value === 3) {
                if (this.placaVehiculo.length >= 2) {
                    setTimeout(() => this.getReceiverVehiculos(), 200);
                }
            }
        },
        getReceiverVehiculos(){
            axios
            .post(process.env.VUE_APP_API_URL + 'vehiculos/buscar',{
                token: this.$store.getters.userToken,
                p: this.placaVehiculo,
            })
            .then(response => (
                this.listaVehiculos = response.data,
                this.listaVehiculo = true,
                this.sinDatos(response.data)  
            ))
            .catch(function (error){
                this.listaVehiculo = false,
                console.log(error)
            }) 
        },
        sinDatos(value){
            if(value.length == 0){
                this.$snotify.warning('Información no registrada','Ups!')
            }
        },
        getReceiverConductor(){
            axios
            .post(process.env.VUE_APP_API_URL + 'conductor/buscar',{
                token: this.$store.getters.userToken,
                p: this.numDoc,
            })
            .then(response => (
                this.listaConductores = response.data,
                this.listaConductor = true,
                this.sinDatos(response.data)                       
            ))
            .catch(function (error){
                this.listaConductor = false,
                console.log(error)
            }) 
        },
        closeListConductorAsociado(){
            this.listaConductorAsociado = false
        },
        seleccionarConductorAsociado(){
            this.listaConductorAsociado = true,
            this.listaConductor = false
        },
        setReceiverConductorAsociado(item){
            this.numDoc = item.nroDocumento,
            this.nombreConductor = item.nombres,
            this.apellidoConductor = item.apellidos,
            this.numLicencia = item.nroLicencia,
            this.listaConductorAsociado = false
        },
        listarConductores(){
            this.listaConductorAsociado = false,
            axios
            .post(process.env.VUE_APP_API_URL + 'conductor/listar',{
                token: this.$store.getters.userToken,
                p: this.numDoc,
            })
            .then(response => (
                this.listaConductores = response.data.data,
                this.listaConductor = true,
                this.sinDatos(response.data.data)                      
            ))
            .catch(function (error){
                this.listaConductor = false,
                console.log(error)
            }) 
        },
        closeListConductor(){
            this.listaConductor = false;
        },
        getReceiverConductorNombre(){
            axios
            .post(process.env.VUE_APP_API_URL + 'conductor/buscar',{
                token: this.$store.getters.userToken,
                p: this.nombreConductor,
            })
            .then(response => (
                this.listaConductores = response.data,
                this.listaConductor = true,
                this.sinDatos(response.data)                         
            ))
            .catch(function (error){
                this.listaConductor = false,
                console.log(error)
            }) 
        },
        guardarConductor(){
            let conductor = {}
                if(this.recibeConductorSecundario.length == 0 || this.indexConductor == 0){
                    conductor.tipoConductor = 'Principal'
                }else{
                    conductor.tipoConductor = 'Secundario'
                }
                conductor.tipoDocumentoConductor = this.tipoDocConductor;
                conductor.numeroDocumentoConductor = this.numDoc;
                conductor.nombresConductor = this.nombreConductor;
                conductor.apellidosConductor = this.apellidoConductor;
                conductor.numeroLicenciaConductor = this.numLicencia;
            if(this.indexConductor != -1){
                Object.assign(this.recibeConductorSecundario[this.indexConductor], conductor)
                this.indexConductor = -1
                this.botonEditarConductor = false;
            }else{
                this.recibeConductorSecundario.push(conductor);
            }
            this.tipoDocConductor = '6';
            this.numDoc = '';
            this.nombreConductor = '';
            this.apellidoConductor = '';
            this.numLicencia = '';
            if(this.recibeConductorSecundario.length == 1){
                this.bloquearCampoConductor = true;
            }
        },
        editarConductor(){     
            this.guardarConductor()
        },
        editarDatosConductor(index, item){
           this.indexConductor = index;
           this.tipoDocConductor = item.tipoDocumentoConductor
           this.numDoc = item.numeroDocumentoConductor;
           this.nombreConductor = item.nombresConductor;
           this.apellidoConductor = item.apellidosConductor;
           this.numLicencia = item.numeroLicenciaConductor;
           this.botonEditarConductor = true;
           this.bloquearCampoConductor = false;
        },
        eliminarConductor(index){
            this.recibeConductorSecundario.splice(index,1)
            if(this.recibeConductorSecundario.length >= 2){
                this.bloquearCampoConductor = true;
            }else{
                this.bloquearCampoConductor = false;
            }
        },
        listaDeVehiculos(){  
            axios.post(process.env.VUE_APP_API_URL + "vehiculos/listar",{
                token:this.$store.getters.userToken,
            })
            .then(response =>(
                this.listaVehiculos = response.data.data,
                this.listaVehiculo = true,
                this.sinDatos(response.data.data)
            ))
            .catch(error=>(
                console.log('ERROR LISTA INFORMACION',error.response.data)
            ))
        },
        setReceiverVehiculo: function (item) {
            if(item.driver.length > 0){
                this.conductoresAsociados = item.driver
                this.numDoc = item.driver[0].nroDocumento,
                this.nombreConductor = item.driver[0].nombres,
                this.apellidoConductor = item.driver[0].apellidos,
                this.numLicencia = item.driver[0].nroLicencia
            }
            this.placaVehiculo = item.placa
            if(this.bloquearCampoVehiPrincipal){
                this.numCirculacionVehiculo = ''
            }else{
                this.numCirculacionVehiculo = item.nroCirculacionMTC
            }
            this.pesoBrutoTotal = item.pesoBruto,
            this.codEntidadEmisora = item.idEntidad,
            this.numAutorizacionVehiculo = item.numeroPermiso
            // cerrando lista de documentos
            this.listaVehiculo = false;
        },
        getReceiverVehiculosSecundarios(){
            axios
            .post(process.env.VUE_APP_API_URL + 'vehiculos/buscar',{
                token: this.$store.getters.userToken,
                p: this.placaVehiculo,
            })
            .then(response => (
                this.listaVehiculosSecundarios = response.data,
                this.listaVehiculoSecundario = true,
                this.sinDatos(response.data)  
            ))
            .catch(function (error){
                this.listaVehiculo = false,
                console.log(error)
            }) 
        },
        listaDeVehiculosSecundarios(){  
            axios.post(process.env.VUE_APP_API_URL + "vehiculos/listar",{
                token:this.$store.getters.userToken,
            })
            .then(response =>(
                this.listaVehiculosSecundarios = response.data.data,
                this.listaVehiculoSecundario = true,
                this.sinDatos(response.data.data)
            ))
            .catch(error=>(
                console.log('ERROR LISTA INFORMACION',error.response.data)
            ))
        },
        closeListVehiculoSecundario(){
            this.listaVehiculoSecundario = false;
        },
        setReceiverVehiculoSecundario: function (item) {
            this.placaVehiculoSecundario = item.placa,
            // this.numCirculacionVehiculoSecundario = item.nroCirculacionMTC,
            this.codEntidadEmisoraSecundario = item.idEntidad,
            this.numAutorizacionVehiculoSecundario = item.numeroPermiso
            // cerrando lista de documentos
            this.listaVehiculoSecundario = false;
        },
        validarCamposVehiculo(){
            if(this.placaVehiculoSecundario.length >5){
                if(this.placaVehiculo != this.placaVehiculoSecundario){
                    return true;
                }else{
                    return false;
                }
                
            }else{
                return false;
            }
        },
        guardarVehiculoSecundario(){
            let vehiculosSecundario ={}
                vehiculosSecundario.numeroPlacaVehiculo = this.placaVehiculoSecundario;
                // vehiculosSecundario.numeroCirculacionVehiculo = this.numCirculacionVehiculoSecundario ;
                // vehiculosSecundario.nomEntidadEmisora = this.infoEntidadEmisora[this.codEntidadEmisoraSecundario].nombre; //borrar al enviar
                // vehiculosSecundario.codEntidadEmisora = this.infoEntidadEmisora[this.codEntidadEmisoraSecundario].codigo;
                // vehiculosSecundario.codEdicion = this.codEntidadEmisoraSecundario; //borrar al enviar
                // vehiculosSecundario.numeroAutorizacionVehiculo = this.numAutorizacionVehiculoSecundario;          
            if(this.indexVehiculoSecundario != -1){
                Object.assign(this.recibeVehiculoSecundario[this.indexVehiculoSecundario], vehiculosSecundario)
                this.indexVehiculoSecundario = -1
                this.botonEditar = false;
            }else{
                this.recibeVehiculoSecundario.push(vehiculosSecundario);

            }
            this.placaVehiculoSecundario = '';
            // this.numCirculacionVehiculoSecundario = '';
            this.codEntidadEmisoraSecundario = 0;
            this.numAutorizacionVehiculoSecundario = '';
            if(this.recibeVehiculoSecundario.length >= 2){
                this.bloquearCampoVehiSecundario = true;
            }
        },
        editarVehiculo(){     
            this.guardarVehiculoSecundario()
        },
        editarVehiculoSecundario(index, item){
           this.indexVehiculoSecundario = index;
           this.placaVehiculoSecundario = item.numeroPlacaVehiculo;
        //    this.numCirculacionVehiculoSecundario = item.numeroCirculacionVehiculo;
           this.codEntidadEmisoraSecundario = item.codEdicion;
           this.numAutorizacionVehiculoSecundario = item.numeroAutorizacionVehiculo
           this.botonEditar = true;
           this.bloquearCampoVehiSecundario = false;
        },
        eliminarVehiculoSecundario(index){
            this.recibeVehiculoSecundario.splice(index,1)
            if(this.recibeVehiculoSecundario.length >= 2){
                this.bloquearCampoVehiSecundario = true;
            }else{
                this.bloquearCampoVehiSecundario = false;
            }
        },
        closeListVehiculo(){
            this.listaVehiculo = false;
        },
        validarPlacaSecu(){
            if(this.placaVehiculoSecundario == this.placaVehiculo){
                return false
            }else{
                return true
            }
        },
        validarDatosSunat() {
            axios
                .post(process.env.VUE_APP_API_URL + "usuario/credenciales/sunat", {
                    token: this.$store.getters.userToken
                })
                .then(response => {
                    this.datosSunatGuias = response.data.response;
                    
                    // Validar después de recibir los datos
                    if (!this.datosSunatGuias.client_id || 
                        !this.datosSunatGuias.client_secret || 
                        !this.datosSunatGuias.password || 
                        !this.datosSunatGuias.username) {
                        this.showPopup = true; // Mostrar popup si algún campo está vacío
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        copiarGuiasRemitente(){
            let itemBlank = []
            this.obtieneGuiaDuplicada = this.$store.getters.getDuplicarGuiaRemision
            if(this.obtieneGuiaDuplicada && this.obtieneGuiaDuplicada.receiver){
                const adicional = JSON.parse(this.obtieneGuiaDuplicada.adicional);
                // this.femision = this.obtieneGuiaDuplicada.fechaEmision
                this.tipodeguia = this.obtieneGuiaDuplicada.tipoDocumentoGuia
                this.motivotraslado = this.obtieneGuiaDuplicada.motivoTraslado
                if(this.motivotraslado == '02'){ //INICIO - TIPO COMPRA
                this.tipoDocumentoProveedor = adicional.tipoDocumentoProveedor
                this.numeroDocumentoProveedor = adicional.numeroDocumentoProveedor
                this.denominacionProveedor = adicional.denominacionProveedor
                this.direccionProveedor = adicional.direccionProveedor
                }
                this.receptor.numero = this.obtieneGuiaDuplicada.receiver.idReceptor
                this.receptor.razonSocial = this.obtieneGuiaDuplicada.receiver.razonSocial
                this.receptor.direccion = this.obtieneGuiaDuplicada.receiver.direccionReferencia
                this.indexSerie = 0;    
                this.ubigeoPartida = this.obtieneGuiaDuplicada.ubigeoPartida
                this.direccionPartida = this.obtieneGuiaDuplicada.direccionPartida
                this.ubigeoLlegada = this.obtieneGuiaDuplicada.ubigeoLlegada
                this.direccionLlegada = this.obtieneGuiaDuplicada.direccionLlegada
                //DATOS VEHICULO PRINCIPAL
                    //TRANSPORTE PUBLICO 01
                    if(this.obtieneGuiaDuplicada.modalidadTraslado =='01'){
                        this.modalidaddetraslado = this.obtieneGuiaDuplicada.modalidadTraslado
                        this.tipoDocumentoTransportista = adicional.tipoDocumentoTransportista
                        this.numeroRucTransportista = adicional.numeroRucTransportista
                        this.denominacionTransportista = adicional.denominacionTransportista
                    }//TRANSPORTE PRIVADO 02
                    if(this.obtieneGuiaDuplicada.modalidadTraslado =='02'){
                        this.modalidaddetraslado = this.obtieneGuiaDuplicada.modalidadTraslado
                        this.placaVehiculo = adicional.vehiculoPrincipal.numeroPlacaVehiculo
                        //PUEDE O NO TENER VEHICULOS SECUNDARIOS | (TIPO = AUTO O MOTO)
                        if(Array.isArray(adicional.vehiculosSecundario) && adicional.vehiculosSecundario.length>0){
                            this.recibeVehiculoSecundario = adicional.vehiculosSecundario
                        }
                        //DATOS CONDUCTOR | (TIPO = OTROS VEHICULOS)
                        if(Array.isArray(adicional.conductores) && adicional.conductores.length>0){
                            this.tipoVehiculo = '02'
                            this.numCirculacionVehiculo = adicional.vehiculoPrincipal.numeroCirculacionVehiculo
                            this.recibeConductorSecundario = adicional.conductores
                            this.bloquearCampoConductor = true
                        }
                    }
                //DATOS GUIA REMISION
                this.pesoBruto = this.obtieneGuiaDuplicada.pesoBrutoTotal
                this.fechaInicioTraslado = this.obtieneGuiaDuplicada.fechaInicioTraslado
                this.descripcionMotivoTraslado = adicional.descripcionMotivoTraslado
                this.numeroContenedor = adicional.numeroContenedor
                this.observaciones = adicional.observaciones
                this.informacionAdicional = adicional.informacionAdicional
                
                let duplicarGuiaRemisionItems = this.$store.getters.getDuplicarGuiaRemisionItems
                // this.items = duplicarGuiaRemisionItems
                this.items = duplicarGuiaRemisionItems.map(item => {
                const { adicional, ...resto } = item;
                return adicional != null && adicional !== ''
                    ? { ...resto, adicional }
                    : { ...resto };
                });
            }
            this.$store.commit('duplicarGuiaRemision', itemBlank)
        },
    }
}
</script>

<style >
    .input-requerido::placeholder {
        color:#DB0000;
        opacity: 1;
    }
    .input-placedark::placeholder {
        color:#353333;
        opacity: 0.9;
    }
    .input-dark{
        color:#000000;
        opacity: 1;
    }
    .searcher-field{
        z-index: 1000;
        position: absolute;
        max-height: 400px !important;
        overflow-y: scroll;
        width: 500px;
    }
    .searcher-field-description{
        z-index: 1000;
        position: absolute;
        max-height: 400px !important;
        overflow-y: scroll;
        width: 500px;
        margin-top: -15px;
    }
    .searcher-result{
        font-size: smaller;
        padding: 2px 0px 2px 0px;
        cursor: pointer;
    }
    .searcher-result2{
        padding:20px ;
        cursor: pointer;
    }
    .sinresultados{
        padding: 0 5px 0 5px;  
    }
    .ubigeollegada{
        margin-top: 10px
    }
    .titulosPrimarios{
        padding:0px;
        margin: 0px 0px 0px 0px;
        color: #00b3b3;
    }
    .acciones-espacio {
        margin-right: 10px;
    }
    .botonesemitirNC{
        width: 80px;
        margin-left: 15px;
    }
    .upload-btn-wrapper {
        position: relative;
        overflow: hidden;
        display: inline-block;
    }
    .upload-btn-wrapper input[type=file] {
        font-size: 100px;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
    }
    .estilo {
        border: 2px solid teal;
        color: white;
        background-color: teal;
        padding: 8px 20px;
        border-radius: 5px;
        font-weight: bold;
    }
    .searcher-fieldconductor{
        z-index: 1000;
        position: absolute;
        max-height: 200px !important;
        overflow-y: scroll;
        width: 720px;
    }
    .searcher-result3{
        background-color: #77AEC1;
    }
    .centrarTitulo{
        text-align: center;
    }
    .tablaborde{
        border: 1px solid #B8cdd5;
    }
    .searcher-result2 {
        background-color: white;
        font-size: 1em;
        cursor: pointer;
    }
    .searcher-result2 :hover{
        background-color: #DAF1F9;
        border:1px solid grey
    }
    .searcher-fieldplaca{
        z-index: 1000;
        position: absolute;
        max-height: 200px !important;
        overflow-y: scroll;
        width: 750px;
    }
    .titulosSecundarios{
        padding:0px;
        margin: 0px;
        color: red;
    }
    .bordesYtexto{
        border: 1px solid;
        color:black;
    }
    .bordesYtexto input::placeholder{
 
        color:black;
    }
    .input-buscar::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: black;
        opacity: 1; /* Firefox */
    }

    .input-buscar:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: black;
    }

    .input-buscar::-ms-input-placeholder { /* Microsoft Edge */
        color: black;
    }
    .texto-arriba {
        position: absolute;
        top: -20px; /*Ajusta este valor según sea necesario */
        color:red;
    }
    .popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  width: 350px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}
.campo-con-label {
    position: relative;
}

.campo-con-label label {
    position: absolute;
    top: -10px;
    left: 10px;
    background: #baf9f9;
    padding: 0 5px;
    font-size: 12px;
    z-index: 1;

}

</style>

